import moment from 'moment';
import angular from 'angular';
import accountModule from '../../../app.js';
import US_STATES from '../../../data/us.states.js';
import CA_PROVINCES from '../../../data/ca.provinces.js';
import GB_COUNTIES from '../../../data/gb.counties.js';
import AU_STATES from '../../../data/au.states.js';
import NZ_STATES from '../../../data/nz.states.js';
import imageDocs from './doc-definition-images';
import {PhoneNumberFormatter,
    AddressConfigsFactory,
    AddressFormatterFactory,
    commonUtil,
    configManager,
    cookieUtil,
    localeUtil,
    qas,
    strings,
    userProfileManager,
    AccountTypeEnum,
    birthdayPicker,
    PersonalTaxIdFormatterFactory,
    PersonalTaxIdConfigsFactory,
    PrivacyPreferenceConfigs,
    AccountConfigManager} from '@nuskin/ns-common-account';

import '../profile.scss';

accountModule.service('addressFormatterFactory', function() {
    return AddressFormatterFactory;
});
accountModule.service('addressConfigsFactory', function() {
    return AddressConfigsFactory;
});
accountModule.service('birthdayPicker', function() {
    return birthdayPicker;
});
accountModule.service('personalTaxIdFormatterFactory', function() {
    return PersonalTaxIdFormatterFactory;
});
accountModule.service('personalTaxIdConfigsFactory', function() {
    return PersonalTaxIdConfigsFactory;
});
accountModule.service('privacyPreferenceConfigs', function() {
    return PrivacyPreferenceConfigs;
});
accountModule.service('configManager', function() {
    return configManager;
});
accountModule.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
accountModule.service('strings', function() {
    return strings;
});

accountModule.controller('personalController', ['personalService',
    'addressFormatterFactory',
    'addressConfigsFactory',
    '$http',
    '$window',
    '$scope',
    '$timeout',
    'birthdayFactory',
    '$rootScope',
    '$uibModal',
    '$sce',
    'birthdayPicker',
    'personalTaxIdFormatterFactory',
    'personalTaxIdConfigsFactory',
    'privacyPreferenceConfigs',
    'strings',
    'configManager',
    'AccountConfigManager',
    function(personalService,
        addressFormatterFactory,
        addressConfigsFactory,
        $http,
        $window,
        $scope,
        $timeout,
        birthdayFactory,
        $rootScope,
        $uibModal,
        $sce,
        birthdayPicker,
        personalTaxIdFormatterFactory,
        personalTaxIdConfigsFactory,
        privacyPreferenceConfigs,
        strings,
        configManager,
        AccountConfigManager
    ) {
        var self = this;
        var USER_TYPE = userProfileManager.USER_TYPE;

        var accountConfigManager = AccountConfigManager.getConfig(configManager);
        self.countryCode = accountConfigManager.site['countryCode'];
        var dateFormat = accountConfigManager.site['dateFormat'];
        var dateFormatting = '';
        var language = accountConfigManager['languageCode']; // injected from the wrapper
        var marketDateMaskFormat = accountConfigManager.site['dateMask'];
        var defaultSponsorIds = accountConfigManager.site['defaultSponsorIds'];
        var addressConfigs = addressConfigsFactory.getAddressConfigs(self.countryCode);
        var addressFormatter = addressFormatterFactory.getAddressFormatter(self.countryCode);
        var personalTaxIdFormatter = personalTaxIdFormatterFactory.getTaxIdFormatter(self.countryCode);
        var personalTaxIdConfigs = personalTaxIdConfigsFactory.getTaxIdConfigs(self.countryCode);

        self.model = {};

        var fileUploadModalTemplate = 'fileuploadmodal.html';
        var addressValidationModalTemplate = 'addressVerification.html';
        var cropModalMarkup = 'pictureCropModal.html';
        var emailLabel = strings.get('tdc_commemailtext');
        var textLabel = strings.get('tdc_commtextlabel');
        var notSpecifiedLabel = strings.get('tdc_notSpecified');

        self.model.zipMaxLength = self.model.zipMinLength = null;
        self.model.mobileAddress = 'account-mobile';
        self.model.desktopAddress = 'account-desktop';
        self.model.language = language;
        self.model.dateFormat = dateFormat;
        self.model.addressConfigs = addressConfigs;
        self.model.addressFormatter = addressFormatter;

        // Get Market-specific data
        switch (self.countryCode) {
        case 'CA':
            self.model.stateList = CA_PROVINCES;
            self.model.zipMaxLength = 7;
            self.model.zipMinLength = 7;
            break;
        case 'AU':
            this.stateList = AU_STATES;
            this.zipMaxLength = 5;
            this.zipMinLength = 4;
            break;
        case 'NZ':
            this.stateList = NZ_STATES;
            this.zipMaxLength = 4;
            this.zipMinLength = 4;
            break;
        case 'GB':
            self.model.stateList = GB_COUNTIES;
            self.model.zipMaxLength = 8;
            self.model.zipMinLength = 6;
            break;
        default:
            self.model.stateList = US_STATES;
            self.model.zipMaxLength = 10;
            self.model.zipMinLength = 5;
            break;
        }
        self.model.countryCode = self.countryCode;

        self.accSettingsVisible = false;
        self.isSponsorSkipped = false;

        self.isPreferredOrRetail = false;
        self.isFamilyMember = false;
        self.isAssociate = false;
        self.isIndividualDistributorSponsor = false;
        self.showCopyDownloadBtn = true;
        self.profileEmail = '';
        self.contactEmailReadOnly = '';
        self.credentials = {
            'emailComponent': {},
            'phoneComponent': {}
        };


        self.passwordCredentials = {
            userEmailField: '',
            userPhoneField: '',
            userPassword: ''
        };
        // Flag for duplicate Email ID
        self.model.isEmailIDDuplicate = false;
        self.model.isSubmitted = false;

        self.orderHistoryConfigs = '';
        self.orderHistoryDetailsConfigs = '';

        var templateurl = angular.element($('#templateurl')).val();

        self.model.currentTab = 'contact';
        self.model.isPersonalSelected = true;
        self.model.isBusinessSelected = false;
        self.model.isAddressSubmitted = false;
        self.model.isPasswordMismatch = false;

        // user data processing
        self.model.userdataOriginal = {};
        self.model.userdata = {};
        self.model.sponser = {};
        self.model.isPreferredNamePresent = false;


        // contact properties
        self.model.showContactForm = false;
        self.model.contactOriginal = {};
        self.model.contact = {};

        // overview properties
        self.model.showAddressForm = false;
        self.model.address = {};
        self.model.displayAddress = {};
        self.model.addressOriginal = {};
        self.model.headerInfo = {};
        self.model.emailInvalid = false;
        self.model.emailRequired = false;
        self.model.isCompany = false;

        // login properties
        self.model.showLoginForm = false;
        self.model.loginPrefOriginal = {};
        self.model.loginPref = {};

        // family
        self.model.associatesLimitAboveMd = 3;
        self.model.associatesLimitBelowMd = 4;
        self.model.familyList = [];
        self.model.deleteFamilyList = [];
        self.model.familyListOrg = [];

        // login properties
        self.model.loginPrefOriginal = {};
        self.model.loginPref = {};
        self.model.switchImage = {
            'onImage': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/css/toggle-on.svg',
            'offImage': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/css/toggle-off.svg'
        };


        // personal details
        self.model.showPersonalForm = false;
        self.model.hasError = {};
        self.model.years = [];
        var yearValue = new Date();
        for (var i = (yearValue.getFullYear() - 18); i > (yearValue.getFullYear() - 100); i--) {
            self.model.years.push(i);
        }
        self.model.year = '';
        self.model.month = '';
        self.model.day = '';
        self.model.showBirthdayError = false;
        self.model.birthdate = '';
        self.model.personalDetailsOriginal = {};
        self.model.originalBirthdate = {};
        self.model.personalDetails = {};

        // privacy preferences
        self.model.showPrivacyForm = false;
        self.model.privacy = {};
        self.model.privacyOriginal = {};

        // shipping
        self.model.shipping = [];
        self.model.currentshippingOrg = {};
        self.model.currentshipping = {};
        self.model.hideAddPanel = true;

        // addresses
        self.model.hideAddresses = accountConfigManager.site['hideAddresses'];

        // billing
        self.model.billing = [];
        self.model.currentbillingOrg = {};
        self.model.currentbilling = {};
        self.model.hideBillingAddPanel = true;

        // order history
        self.model.hideOrderHistory = accountConfigManager.site['hideOrderHistory'];

        self.model.hidePayments = accountConfigManager.site['hidePayments'];

        // communication
        self.model.communication = {};
        self.model.showComForm = false;
        self.model.communicationOriginal = {};
        self.model.emailDuplicateCheckValue='';

        // favorites
        self.model.hideFavoritesList = accountConfigManager.site['hideFavoritesList'];

        // story
        self.model.story = {};
        self.model.copyButtonText = 'copy';
        self.model.story.isFirstTime = true;
        self.model.isCopyClicked = false;
        self.model.isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        self.model.story.personalMoment = '';
        self.model.story.createAConnection = '';
        self.model.story.theResoultion = '';

        // Resend Email Changes
        self.model.isEmailAddressValidated = true;

        // distributor
        self.model.distributor = {};

        self.model.showPersonalTaxId = personalTaxIdConfigs.showField;
        self.model.personalDetails.primaryPersonalTaxId = [];

        var serviceCallFailureMsg = strings.get('tdc_serviceCallFailureMsg');
        self.otherOptionHide=accountConfigManager.site['otherOptionHide'];

        // minimum age check
        self.ageLimit = accountConfigManager.site['minAge'];
        var currentDate = new Date();
        self.validAgeDate = new Date(currentDate.getFullYear() - self.ageLimit, currentDate.getMonth(),
            currentDate.getDate());

        // Removing call for verified Email Address
        // Richards thoughts:
        // The email verification is not a required function. It was originally added to support future development for
        // client side account create. This plan has been abandoned so we should be fine leaving it out on both the
        // .mynuskin.com and .nuskin.com sites.
        /*
        var gigyaProfileDataPromise = personalService.loadGigyaProfileDetails();
        gigyaProfileDataPromise.then(function(data) {
            if (undefined != data) {
                self.model.isEmailAddressValidated = personalService.isEmailVerified(data);
            }
        });
        */

        // if user logged in using legacy sigin then UserProfileMasterInfo and userMarket will be null
        var userMarket = userProfileManager.returnUserMarket();

        window.onload = function() {
            checkUrl();
        };

        // On page load fetch the user preference data from hybris
        this.init = function() {
            $(window).scrollTop(0);

            loadOrderHistoryConfigs();
            loadOrderHistoryDetailsConfigs();
            loadPrivacyPreferences();

            window.document.title = strings.get('tdc_personalTitle');
            if (userProfileManager.isUserLoggedIn()) {
                if (userMarket != self.countryCode) {
                    $window.location.href = localeUtil.replaceUrlLocale(window.location.href, userMarket, language);
                }

                // Set User ID in accountSettingsPersonalService for all the service calls
                var userProfileInfo = userProfileManager.getUserProfileMasterInfo();
                if (userProfileInfo) {
                    personalService.setUserId(userProfileInfo.userId);
                    $rootScope.$on('show-picture-modal', function(evt, arg) {
                        showPictureCropModal(true);
                    });
                }

                self.handleMBSScriptTexts = function(isDownload) {
                    var content = null;
                    if (!isDownload) {
                        var personalMoment = self.modifyCustomText(self.model.story.personalMoment);
                        var createAConnection = self.modifyCustomText(self.model.story.createAConnection);
                        var theResoultion = self.modifyCustomText(self.model.story.theResoultion);
                        content = $sce.trustAsHtml('<p>' + personalMoment + '</p><p>' + createAConnection
                            + '</p><p>' + theResoultion + '</p>');
                    } else {
                        content = self.model.story.personalMoment + '\n\n' + self.model.story.createAConnection
                            + '\n\n' + self.model.story.theResoultion;
                    }
                    return content;
                };


                self.modifyCustomText = function(inputSource) {
                    var customText = inputSource;
                    if (customText) {
                        customText = customText.replace(/\r?\n/g, '<br />');
                    }
                    return customText;
                };

                self.model.updateEmail = function() {
                    self.contactEmailReadOnly = self.model.contact.email;
                };

                var configData = personalService.getLanguageListFromLocale(self.countryCode);
                configData.then(function(data) {
                    self.model.languageList = data;
                    if (self.model.languageList.length === 0) {
                        self.model.languageList = {
                            code: 'en',
                            name: 'English'
                        };
                    }
                    // The loadPersonalDetails has to be loaded after the languageList
                    self.loadPersonalDetails();
                });

                self.getElementValue = function(id) {
                    var element = angular.element(id);
                    if (element != undefined && element != null) {
                        return element.val();
                    } else {
                        return undefined;
                    }
                };

                self.addressText1= strings.get('tdc_streetAddress1');
                self.addressText2= strings.get('tdc_streetAddress2');
                self.cityText= strings.get('tdc_city');
                self.stateText=strings.get('tdc_state');
                self.zipText=strings.get('tdc_zip');
                self.stError1=strings.get('tdc_streetaddress1error');
                self.autocompleteStError1=strings.get('tdc_autocompletestreetaddress1error');
                self.cityError=strings.get('tdc_cityerror');
                self.stateError=strings.get('tdc_stateerror');
                self.zipError=strings.get('tdc_ziperror');
                self.zipLengthError=strings.get('tdc_zipLengthError');
                self.blockedPostalCodeError=strings.get('tdc_blockedPostalCodeError');

                self.addressTranslations={
                    'marketSelectHK': strings.get('tdc_marketSelectHK'),
                    'marketSelectMO': strings.get('tdc_marketSelectMO'),
                    'address1': self.addressText1,
                    'address2': self.addressText2,
                    'city': self.cityText,
                    'state': self.stateText,
                    'zipcode': self.zipText,
                    'stError1': self.stError1,
                    'cityError': self.cityError,
                    'stateError': self.stateError,
                    'zipLengthError': self.zipLengthError,
                    'blockedPostalCodeError': self.blockedPostalCodeError,
                    'zipError': self.zipError,
                    'autocompleteStError1': self.autocompleteStError1
                };

                self.personData='';

                self.model.address = {
                    'streetAddress': self.model.address.streetAddress,
                    'streetAddress2': self.model.address.streetAddress2,
                    'city': self.model.address.city,
                    'state': self.model.address.state,
                    'zipcode': self.model.address.zipcode,
                };

                switch (self.model.dateFormat) {
                case 'DMY':
                    dateFormatting = 'DD-MM-YYYY';
                    break;
                case 'MDY':
                    dateFormatting = 'MM-DD-YYYY';
                    break;
                case 'YMD':
                    dateFormatting = 'YYYY-MM-DD';
                    break;
                }
            } else if (!nuskin.util.isAuthor()) {
                // if user has logged in using legacy signin and is trying to access their account settings page,
                // redirect user to re login using new signin for their market and language
                let languageCode = cookieUtil.getCookie('languageCode');
                let countryCode = cookieUtil.getCookie('countryCode');
                userProfileManager.deleteUserProfileCookiesAndSignOut(`/content/nuskin/${languageCode + '_' + countryCode}/sign-in`);
            }
            self.subscribeEventListeners();
        };

        this.subscribeEventListeners = function() {
            /*
                Communication Preferences checkboxes
             */
            document.getElementById('desktop-personal-email').addEventListener('change', function() {
                self.model.communication.emailIsOpted = document.getElementById('desktop-personal-email').hasAttribute('checked');
            });
            document.getElementById('mobile-personal-email').addEventListener('change', function() {
                self.model.communication.emailIsOpted = document.getElementById('mobile-personal-email').hasAttribute('checked');
            });
            document.getElementById('desktop-personal-text').addEventListener('change', function() {
                self.model.communication.textIsOpted = document.getElementById('desktop-personal-text').hasAttribute('checked');
            });
            document.getElementById('mobile-personal-text').addEventListener('change', function() {
                self.model.communication.textIsOpted = document.getElementById('mobile-personal-text').hasAttribute('checked');
            });

            /*
                Privacy Preferences checkboxes
             */
            document.getElementById('mobile-contactcheck1').addEventListener('change', function() {
                self.model.privacy.showContactInfoChecked = document.getElementById('mobile-contactcheck1').hasAttribute('checked');
                updateContactInfoAttribute(self.model.privacy.showContactInfoChecked);
            });
            document.getElementById('desktop-contactcheck1').addEventListener('change', function() {
                self.model.privacy.showContactInfoChecked = document.getElementById('desktop-contactcheck1').hasAttribute('checked');
                updateContactInfoAttribute(self.model.privacy.showContactInfoChecked);
            });
            document.getElementById('mobile-contactcheck2').addEventListener('change', function() {
                self.model.privacy.showContactInfoToUplineChecked = document.getElementById('mobile-contactcheck2').hasAttribute('checked');
                updateContactInfoToUplineAttribute(self.model.privacy.showContactInfoToUplineChecked);
            });
            document.getElementById('desktop-contactcheck2').addEventListener('change', function() {
                self.model.privacy.showContactInfoToUplineChecked = document.getElementById('desktop-contactcheck2').hasAttribute('checked');
                updateContactInfoToUplineAttribute(self.model.privacy.showContactInfoToUplineChecked);
            });
            document.getElementById('mobile-contactcheck3').addEventListener('change', function() {
                self.model.privacy.showContactInfoToFamilyChecked = document.getElementById('mobile-contactcheck3').hasAttribute('checked');
                updateContactInfoToFamilyAttribute(self.model.privacy.showContactInfoToFamilyChecked);
            });
            document.getElementById('desktop-contactcheck3').addEventListener('change', function() {
                self.model.privacy.showContactInfoToFamilyChecked = document.getElementById('desktop-contactcheck3').hasAttribute('checked');
                updateContactInfoToFamilyAttribute(self.model.privacy.showContactInfoToFamilyChecked);
            });
            document.getElementById('mobile-contactcheck4').addEventListener('change', function() {
                self.model.privacy.visibleInSponsorSearchChecked = document.getElementById('mobile-contactcheck4').hasAttribute('checked');
                updateVisibleInSponsorSearchAttribute(self.model.privacy.visibleInSponsorSearchChecked);
            });
            document.getElementById('desktop-contactcheck4').addEventListener('change', function() {
                self.model.privacy.visibleInSponsorSearchChecked = document.getElementById('desktop-contactcheck4').hasAttribute('checked');
                updateVisibleInSponsorSearchAttribute(self.model.privacy.visibleInSponsorSearchChecked);
            });
        };

        /*
            Takes the markets languageList and attempts to assign the first option if one exists.
            If there are multiple, assign the language currently used,
            Assign english as last option.
         */
        var setFallbackPreferredLanguage = function(languageList) {
            if (languageList.length === 1) {
                self.model.communication.languageprefDisplay = languageList[0].name;
                self.model.communication.languagepref = languageList[0].code;
            } else {
                // if there are multiple languages in the list, set current language as the default
                language = languageList.filter(function(item) {
                    return item.code.toLowerCase() === self.model.language.toLowerCase();
                });

                if (language[0]) {
                    self.model.communication.languageprefDisplay = language[0].name;
                    self.model.communication.languagepref = language[0].code;
                } else {
                    self.model.communication.languageprefDisplay = 'English';
                    self.model.communication.languagepref = 'en';
                }
            }
        };

        var setupPreferredLanguage = function(data) {
            var language;
            if (data.person.preferredLanguage) {
                // Find language data based on data.
                language = self.model.languageList.filter(function(item) {
                    return item.code.toLowerCase() === data.person.preferredLanguage.toLowerCase();
                });

                if (language[0]) {
                    self.model.communication.languageprefDisplay = language[0].name;
                    self.model.communication.languagepref = language[0].code;
                } else {
                    setFallbackPreferredLanguage(self.model.languageList);
                }
            } else {
                setFallbackPreferredLanguage(self.model.languageList);
            }
            // redirect to preferred language if the url is different
            var newLanguage = self.model.communication.languagepref.toLowerCase();
            if (self.model.langPref && newLanguage != self.model.langPref) {
                $window.location.href = localeUtil.replaceUrlLocale(window.location.href, '', newLanguage);
            }
        };


        self.loadPersonalDetails = function() {
            var promise = personalService.loadDetails();

            promise.then(function(data) {
                // userdata processing
                if (data.person) {
                    self.personData = data.person;
                    self.model.headerInfo.firstName = data.person.names.local.given;
                    self.model.headerInfo.lastName = data.person.names.local.family;
                    self.model.headerInfo.fullName =self.model.headerInfo.firstName +' '+self.model.headerInfo.lastName;

                    if (data.person.preferredName) {
                        self.model.isPreferredNamePresent = true;
                        self.model.headerInfo.preferredName = data.person.preferredName;
                        self.model.headerInfo.fullName =self.model.headerInfo.preferredName;
                    }

                    self.model.headerInfo.thumbnailURL = $rootScope.accImage = data.person.profileThumbnailUrl;

                    var authoredProfileImageRef = userProfileManager.getProfileImageReference();

                    if (authoredProfileImageRef != null && authoredProfileImageRef != '') {
                        self.model.headerInfo.defaultthumbnailURL = authoredProfileImageRef;
                    } else {
                        self.model.headerInfo.defaultthumbnailURL = '/etc/clientlibs/mecommerce/core/main' +
                            '/css/src/assets/images/css/ic-profile-copy-2.png';
                    }

                    if (data.person.profilePictureUrl) {
                        self.model.headerInfo.profilePictureUrl = data.person.profilePictureUrl;
                    } else {
                        var origImageUrl =self.model.headerInfo.thumbnailURL;
                        if (origImageUrl != undefined && origImageUrl.indexOf('gigya.com') > -1) {
                            origImageUrl = origImageUrl.replace('thumbnail', 'orig');
                        }
                        self.model.headerInfo.profilePictureUrl = origImageUrl;
                    }

                    self.model.distributor.accountID = data.person.accountID;
                }

                var userProfileInfo = userProfileManager.getUserProfileMasterInfo();
                if (userProfileInfo.userType == USER_TYPE.PRIMARY_DISTRIBUTOR
                    || userProfileInfo.userType == USER_TYPE.ASSOCIATE) {
                    self.isPreferredOrRetail = false;
                }
                if (userProfileInfo.userType == USER_TYPE.PREFERRED_CUSTOMER
                    || userProfileInfo.userType == USER_TYPE.RETAIL_CUSTOMER) {
                    self.isPreferredOrRetail = true;
                }
                if (userProfileInfo.userType == USER_TYPE.FAMILY_MEMBER) {
                    self.isFamilyMember = true;
                }

                // See if this account is a Company.
                if (userProfileInfo.accountType && (userProfileInfo.accountType
                    .toUpperCase() === AccountTypeEnum.COMPANY)) {
                    self.model.isCompany = true;
                }

                // Sponsor details
                if ((userProfileInfo.userType !== USER_TYPE.FAMILY_MEMBER) &&
                    (self.isPreferredOrRetail == false || userProfileInfo.userType == USER_TYPE.PREFERRED_CUSTOMER
                        || userProfileInfo.userType == USER_TYPE.RETAIL_CUSTOMER
                        || userProfileInfo.userType == USER_TYPE.ASSOCIATE)) {
                    if (data.sponsor && !angular.equals(data.sponsor, {})) {
                        // The new service does NOT have account type....???
                        if (data.sponsor.accountType != undefined) {
                            if (data.sponsor.accountType.toUpperCase() == 'INDIVIDUAL') {
                                self.isIndividualDistributorSponsor = true;
                            }
                        }
                        if (data.sponsor.id != undefined) {
                            for (i in defaultSponsorIds) {
                                if (defaultSponsorIds[i] == data.sponsor.id) {
                                    self.isSponsorSkipped = true;
                                    break;
                                }
                            }
                        }
                    }
                    if (data.inviter && !angular.equals(data.inviter, {}) && !self.isSponsorSkipped) {
                        var inviter = data.inviter;
                        if (inviter.names.default) {
                            self.model.sponser.firstname = inviter.names.default.given;
                            self.model.sponser.lastname = inviter.names.default.family;
                        }
                        if (inviter.phoneNumbers && inviter.phoneNumbers.mobile) {
                            self.model.sponser.mobilePhoneCode = inviter.phoneNumbers.mobile.country;
                            self.model.sponser.mobilePhoneInput = inviter.phoneNumbers.mobile.value;
                        }
                        self.model.sponser.email = inviter.email;
                        self.model.sponser.image = inviter.profileThumbnailUrl;
                        if (inviter.preferences) {
                            self.model.sponser.showContactInfo = inviter.preferences.showContactInfo;
                        }
                    } else if (data.sponsor && !angular.equals(data.sponsor, {}) && !self.isSponsorSkipped) {
                        if (data.sponsor.primaryPerson) {
                            var sPerson = data.sponsor.primaryPerson;
                            self.model.sponser.image = sPerson.profileThumbnailUrl;
                            if (self.model.sponser.image && (self.model.sponser.image.indexOf('gigya.com') > -1)) {
                                self.model.sponser.image =self.model.sponser.image.replace('thumbnail', 'orig');
                            }

                            if (sPerson.names && sPerson.names.default) {
                                self.model.sponser.firstname = sPerson.names.default.given;
                                self.model.sponser.lastname = sPerson.names.default.family;
                            }
                            self.model.sponser.email = sPerson.email;
                            if (sPerson.phoneNumbers && sPerson.phoneNumbers.mobile) {
                                self.model.sponser.mobilePhoneCode = sPerson.phoneNumbers.mobile.country;
                                self.model.sponser.mobilePhoneInput = sPerson.phoneNumbers.mobile.value;
                            }
                            if (sPerson.preferences) {
                                self.model.sponser.showContactInfo = sPerson.preferences.showContactInfo;
                            }
                        } else {
                            self.model.sponser.image = data.sponsor.profileThumbnailUrl;
                            if (data.sponsor.names && data.sponsor.names.default) {
                                self.model.sponser.firstname = data.sponsor.names.default.given;
                                self.model.sponser.lastname = data.sponsor.names.default.family;
                                self.model.sponser.businessname = data.sponsor.names.default;
                            }
                            if (data.sponsor.phoneNumbers && data.sponsor.phoneNumbers.mobile) {
                                self.model.sponser.mobilePhoneCode = data.sponsor.phoneNumbers.mobile.country;
                                self.model.sponser.mobilePhoneInput = data.sponsor.phoneNumbers.mobile.value;
                            }
                            self.model.sponser.email = data.sponsor.email;
                            if (data.sponsor.preferences) {
                                self.model.sponser.showContactInfo = data.sponsor.preferences.showContactInfo;
                            }
                        }
                    }
                }

                if (userProfileInfo.userType === USER_TYPE.ASSOCIATE) {
                    /*
                     * Todo: Remove Temporary workaround when MEC-11326 is finished for Beta Release
                     */
                    self.isAssociate = true;
                }
                if (self.model.sponser.mobilePhoneInput) {
                    var mobilePhoneCode =self.model.sponser.mobilePhoneCode;
                    self.model.sponser.mobilePhoneInputDisplay = PhoneNumberFormatter
                        .getPhoneDisplayFormat(mobilePhoneCode, self.model.sponser.mobilePhoneInput);
                }
                // contact details
                if (data.person.phoneNumbers) {
                    if (data.person.phoneNumbers.mobile) {
                        sessionStorage.customerMobNumber = data.person.phoneNumbers.mobile.value;
                        self.model.contact.mobilePhoneInput = data.person.phoneNumbers.mobile.value;
                        self.model.contact.mobilePhoneCode = data.person.phoneNumbers.mobile.country;

                        if (self.model.contact.mobilePhoneInput) {
                            self.model.contact.mobilePhoneInput = PhoneNumberFormatter
                                .getPhoneSaveFormat(self.model.contact.mobilePhoneCode, self.model.contact.mobilePhoneInput);
                            self.model.contact.mobilePhoneInputDisplay = PhoneNumberFormatter
                                .getPhoneDisplayFormat(self.model.contact.mobilePhoneCode, self.model.contact.mobilePhoneInput);
                        }

                        self.credentials.phoneComponent.userPhoneField =self.model.contact.mobilePhoneInput;
                        self.credentials.phoneComponent.phoneCode =self.model.contact.mobilePhoneCode;
                    }
                }

                if (data.person.email) {
                    self.model.contact.email = data.person.email;
                    self.profileEmail = data.person.email;
                    self.credentials.emailComponent.userEmailField = data.person.email;
                    self.contactEmailReadOnly = data.person.email;
                }
                if (data.person.addresses) {
                    if (data.person.addresses.local) {
                        if (data.person.addresses.local.country == self.countryCode) {
                            var address = addressFormatter.formatFromService(data.person.addresses.local);
                            self.model.address = address;
                            self.model.displayAddress = addressFormatter.displayForProfile(address);
                        }
                    }
                }

                // personal detail processing
                if (data.person) {
                    self.model.personalDetails.personalId = data.person.id;
                    if (data.person.gender != undefined) {
                        if (data.person.gender.toUpperCase() == 'OTHER' && self.otherOptionHide) {
                            self.model.personalDetails.gender = undefined;
                        } else {
                            self.model.personalDetails.gender = data.person.gender;
                        }
                    }
                    if (data.person.legalIDs) {
                        data.person.legalIDs.forEach(function(item, index, arr) {
                            if (item.type === personalTaxIdConfigs.fieldInSAP) {
                                self.model.personalDetails.primaryPersonalTaxId.push(personalTaxIdFormatter
                                    .maskTaxId(item.value));
                            }
                        });
                    }
                    if (data.person.birthDate) {
                        self.model.personalDetails.birthdate = data.person.birthDate;
                        var bdatestring = (self.model.personalDetails.birthdate).split('-');
                        self.model.year = parseInt(bdatestring[0]);
                        self.model.month = birthdayFactory.findItemById(parseInt(bdatestring[1]), 'M');
                        self.model.day = birthdayFactory.findItemById(parseInt(bdatestring[2]), 'D');
                        self.model.originalBirthdate = {
                            year: self.model.year,
                            month: self.model.month,
                            day: self.model.day
                        };
                        self.model.personalDetails.birthdate = moment(self.model.day + '-' +self.model.month + '-' +self.model.year,
                            'D-M-YYYY').format(dateFormatting);
                    }
                }

                // login pref processing
                if (data.person.email) {
                    self.passwordCredentials.userEmailField = data.person.email;
                    var uname = userProfileManager.getUserProfileMasterInfo().username;
                    if (null != uname && undefined != uname && 0 < uname.length) {
                        self.model.loginPref.username = uname;
                    } else {
                        self.model.loginPref.username = data.person.email;
                    }
                    self.model.loginPref.passwordDisplay = '******';
                    if (self.model.loginPref.loginfacebook == 'Yes') {
                        self.model.switchValue = 'switchOn';
                    } else {
                        self.model.switchValue = 'switchOff';
                    }
                }

                // Billing Information

                // Preferred Language
                setupPreferredLanguage(data);

                // communication preferences
                if (data.person.preferences) {
                    if (data.person.preferences.contactPreference == '' ||
                        data.person.preferences.contactPreference == undefined) {
                        data.person.preferences.contactPreference = 'EMAIL';
                    }
                    if (data.person.preferences.acceptMarketingEmail) {
                        self.model.communication.contactpref = data.person.preferences.acceptMarketingSMS
                            ? emailLabel + ', ' + textLabel : emailLabel;
                    } else {
                        self.model.communication.contactpref = data.person.preferences.acceptMarketingSMS
                            ? textLabel : notSpecifiedLabel;
                    }
                    if (data.person.preferences.acceptMarketingEmail) {
                        self.model.communication.dnd = false;
                        self.model.communication.dndDisplay = 'Yes';
                    } else {
                        self.model.communication.dnd = true;
                        self.model.communication.dndDisplay = 'No';
                    }
                    if (data.person.preferences.acceptMarketingEmail) {
                        self.model.communication.emailIsOpted = true;
                    } else {
                        self.model.communication.emailIsOpted = false;
                    }
                    updateEmailCheckboxAttribute(self.model.communication.emailIsOpted);
                    if (data.person.preferences.acceptMarketingSMS) {
                        self.model.communication.textIsOpted = true;
                    } else {
                        self.model.communication.textIsOpted = false;
                    }
                    updateTextCheckboxAttribute(self.model.communication.textIsOpted);
                }

                // Privacy Preferences from Read
                if (data.person.preferences) {
                    var dPrivacyOptionInfo = data.person.preferences;
                    if ((typeof dPrivacyOptionInfo.showContactInfo !== 'undefined')
                        && (dPrivacyOptionInfo.showContactInfo !== null)) {
                        self.model.privacy.showContactInfoChecked = dPrivacyOptionInfo.showContactInfo;
                        updateContactInfoAttribute(self.model.privacy.showContactInfoChecked);
                    }
                    if ((typeof dPrivacyOptionInfo.showContactInfoToFirstUpLine !== 'undefined')
                        && (dPrivacyOptionInfo.showContactInfoToFirstUpLine !== null)) {
                        self.model.privacy.showContactInfoToUplineChecked =
                            dPrivacyOptionInfo.showContactInfoToFirstUpLine;
                        updateContactInfoToUplineAttribute(self.model.privacy.showContactInfoToUplineChecked);
                    }
                    if ((typeof dPrivacyOptionInfo.showContactInfoToFamilyAndFriends !== 'undefined')
                        && (dPrivacyOptionInfo.showContactInfoToFamilyAndFriends !== null)) {
                        self.model.privacy.showContactInfoToFamilyChecked =
                            dPrivacyOptionInfo.showContactInfoToFamilyAndFriends;
                        updateContactInfoToFamilyAttribute(self.model.privacy.showContactInfoToFamilyChecked);
                    }
                    if ((typeof dPrivacyOptionInfo.visibleInSponsorSearch !== 'undefined')
                        && (dPrivacyOptionInfo.visibleInSponsorSearch !== null)) {
                        self.model.privacy.visibleInSponsorSearchChecked = dPrivacyOptionInfo.visibleInSponsorSearch;
                        updateVisibleInSponsorSearchAttribute(self.model.privacy.visibleInSponsorSearchChecked);
                    }
                    if ((typeof dPrivacyOptionInfo.visibleInScannerLocator !== 'undefined')
                        && (dPrivacyOptionInfo.visibleInScannerLocator !== null)) {
                        self.model.privacy.visibleInScannerLocatorChecked = dPrivacyOptionInfo.visibleInScannerLocator;
                    }
                }
                self.accSettingsVisible = true;
                if (window.location.search.length > 0) {
                    var url = new URL(window.location.href);
                    self.model.currentTab = url.searchParams.get('loadTab');
                    if (self.model.currentTab !=undefined && self.model.currentTab!='' && self.model.currentTab!=null) {
                        self.model.loadTab(self.model.currentTab);
                    }
                }
            });
        };

        self.isShowingPersonalTaxId = function() {
            if (self.model.showPersonalTaxId) {
                if (self.isPreferredOrRetail || self.isFamilyMember) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        };

        var loadOrderHistoryConfigs = function() {
            self.orderHistoryTranslations = {
                orderHistory: strings.get('tdc_orderHistoryText')
            };
        };
        var loadOrderHistoryDetailsConfigs = function() {
            self.orderHistoryDetailsTranslations = {
                orderHistoryDetails: strings.get('tdc_orderHistoryDetails')
            };
        };

        var checkUrl = function() {
            if (window.location.href.indexOf('?loadTab=communication') > 0) {
                document.getElementById('mobile-comm-pref-tab').className +=' in';
                personalService.scrollToTop('#mobile-comm-pref-tab');
            }
        };
        var showPictureCropModal = function(isModalProfilePic, imageFileBlob, editFormModel) {
            if (isModalProfilePic) {
                var pictureModalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: cropModalMarkup,
                    controller: ['$uibModalInstance', 'uploadedImageFileBlob', 'editFormModel', '$scope',
                        function($uibModalInstance, uploadedImageFileBlob, editFormModel, $scope) {
                            var pictureModalSelf = this;
                            var rotationDegrees = 0;
                            pictureModalSelf.profilePictureBlob = uploadedImageFileBlob;
                            pictureModalSelf.csstransition = '800ms ease';
                            pictureModalSelf.cssrotate = 'rotate(' + rotationDegrees + 'deg)';
                            pictureModalSelf.rotation = {};
                            pictureModalSelf.croppedImg = null;
                            pictureModalSelf.editFormModel = editFormModel;

                            $uibModalInstance.rendered.then(function(data) {
                                $('#crop-image-p').cropper({
                                    aspectRatio: 1 / 1,
                                    scalable: false,
                                    movable: false,
                                    zoomable: false
                                });
                            }, function(data) {
                                // console.info('Error opening modal window');
                            });

                            pictureModalSelf.savePicture = function() {
                                pictureModalSelf.croppedImg = pictureModalSelf.editFormModel.profileImage =
                                    $('#crop-image-p').cropper('getCroppedCanvas').toDataURL('image/jpeg', 1.0);
                                $uibModalInstance.close(pictureModalSelf);
                            };

                            pictureModalSelf.cancelPicture = function() {
                                pictureModalSelf.croppedImg = '';
                                $uibModalInstance.close(pictureModalSelf);
                            };

                            pictureModalSelf.rotatePicture = function(direction) {
                                if (direction) {
                                    $('#crop-image-p').cropper('rotate', -90);
                                } else {
                                    $('#crop-image-p').cropper('rotate', 90);
                                }
                            };

                            $scope.$on('$locationChangeStart', function($event) {
                                $uibModalInstance.dismiss();
                            });
                        }],
                    controllerAs: 'ctrl',
                    windowClass: 'app-modal-window modal-crop-photo',
                    resolve: {
                        uploadedImageFileBlob: function() {
                            if (imageFileBlob) {
                                return imageFileBlob;
                            }
                        },
                        editFormModel: function() {
                            if (editFormModel) {
                                return editFormModel;
                            }
                        }
                    }
                });

                pictureModalInstance.result.then(function(data) {
                    modalPopupInstance(fileUploadModalTemplate, 'editProfile',
                        'app-modal-window file-upload-popup personal-section-popup',
                        true, data.croppedImg, data.editFormModel);
                }, function() {
                    modalPopupInstance(fileUploadModalTemplate, 'editProfile',
                        'app-modal-window file-upload-popup personal-section-popup', false);
                    // console.info('error');
                });
            }
        };


        // Method to switch between left navigations tabs in My Profile
        self.model.loadTab = function(currentTab) {
            self.model.currentTab = currentTab;
            // Collapsing The Forms when the Tab is changed
            // Billing and Shipping is Hidden Here
            // close all here conditionally
            if (currentTab != 'contact' && self.model.showContactForm == true) {
                try {
                    self.model.cancelContact();
                } catch (e) {}
            }
            if (currentTab != 'personal' && self.model.showPersonalForm == true) {
                try {
                    self.model.cancelPersonalDetails();
                } catch (e) {}
            }
            if (currentTab != 'login' && self.model.showLoginForm == true) {
                try {
                    self.model.cancelLoginPref();
                } catch (e) {}
            }
            if (currentTab != 'addresses' && self.model.showAddressesForm == true) {
                try {
                    self.model.cancelAddresses();
                } catch (e) {}
            }
            if (currentTab != 'communication' && self.model.showComForm == true) {
                try {
                    self.model.cancelCommunication();
                } catch (e) {}
            }
            if (currentTab != 'family' && self.model.showEditStateFamily == true) {
                try {
                    self.model.cancelDeleteFamily();
                } catch (e) {}
            }
            if (currentTab != 'privacy' && self.model.showPrivacyForm == true) {
                try {
                    self.model.cancelPrivacyPref();
                } catch (e) {}
            }
            if (currentTab != 'payments' && self.model.showPaymentsForm == true) {
                try {
                    self.model.cancelPayments();
                } catch (e) {}
            }
        };

        self.model.findGuestEmail = function(email) {
            angular.forEach(self.model.familyList, function(item) {
                if (item.email == email) {
                    return false;
                }
            });
            return true;
        };
        self.model.executeInvite = function(emailId) {
            var promise = personalService.getInvitationId();
            promise.then(function(data) {
                var resendtemplateurl = angular.element('#resendtemplateurl').val();
                var templateUrl = resendtemplateurl;
                if (resendtemplateurl.indexOf('http') !== 0) {
                    templateUrl = $window.location.protocol + '//'
                        + $window.location.host + resendtemplateurl + '.html';
                }
                for (i in data) {
                    if (data[i].guestEmailId == emailId) {
                        var dataModel = {
                            firstname: data[i].guestFirstName,
                            lastname: data[i].guestLastName
                        };
                        var emailPromise = personalService.sendEmailInvite(emailId, data[i].invitationGuId,
                            templateUrl, userProfileManager.getUserProfileMasterInfo().userId, dataModel);
                        emailPromise.then(function(status) {});
                        break;
                    }
                }
            });
        };

        /** ************************************************************************************************
         My Profile Header Section
         **************************************************************************************************/


        self.model.editProfile = function() {
            modalPopupInstance(fileUploadModalTemplate, 'editProfile',
                'app-modal-window file-upload-popup personal-section-popup', true);
        };

        /** ************************************************************************************************
         My Profile Contact Details Section
         **************************************************************************************************/
        self.model.editContact = function() {
            self.model.contactOriginal = angular.copy(self.model.contact);
            self.credentials.emailComponent.userEmailField =self.model.contact.email;
            self.credentials.phoneComponent.userPhoneField =self.model.contact.mobilePhoneInput;
            if (null != self.contactform && self.contactform != undefined) {
                self.contactform.$setUntouched();
                self.contactform.$setPristine();
            }
            self.model.isEmailIDDuplicate = false;
            self.model.showContactForm = true;
        };
        self.updateUserInfoAndCookie = function() {
            // update detail info
            var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
            userProfileDetailInfo.profileContactInfo.email = self.credentials.emailComponent.userEmailField;
            userProfileManager.setUserProfileDetailInfo(userProfileDetailInfo);

            // Setting BASIC INFO
            cookieUtil.setCookie('basicInfo',
                'US-EN-' + self.credentials.emailComponent.userEmailField, {path: '/'});

            // update master info
            var userProfileMasterInfo = userProfileManager.getUserProfileMasterInfo();
            userProfileMasterInfo.emailId = self.credentials.emailComponent.userEmailField;
            userProfileManager.setUserProfileMasterInfo(userProfileMasterInfo);
        };

        self.saveContactFormUpdates = function(address) {
            self.model.contact.email = self.credentials.emailComponent.userEmailField;
            self.model.contact.mobilePhoneInput = PhoneNumberFormatter
                .getPhoneSaveFormat(self.model.contact.mobilePhoneCode, self.model.contact.mobilePhoneInput);
            self.model.contact.mobilePhoneInputDisplay = PhoneNumberFormatter
                .getPhoneDisplayFormat(self.model.contact.mobilePhoneCode, self.model.contact.mobilePhoneInput);

            var data = {
                contact: self.model.contact
            };

            if (address) {
                data.address = address;
            }

            var promise = personalService.setContactDetails(data);
            promise.then(function(response) {
                if (response.status == 200 || response.status == 201) {
                    if (self.model.contact.mobilePhoneInput) {
                        // Storing phone number for Customer in session
                        sessionStorage.customerMobNumber =self.model.contact.mobilePhoneInput;

                        self.model.contact.mobilePhoneInput = PhoneNumberFormatter
                            .getPhoneSaveFormat(self.model.contact.mobilePhoneCode, self.model.contact.mobilePhoneInput);
                        self.model.contact.mobilePhoneInputDisplay = PhoneNumberFormatter
                            .getPhoneDisplayFormat(self.model.contact.mobilePhoneCode, self.model.contact.mobilePhoneInput);
                    }
                    self.model.contactOriginal.email =self.model.contact.email;
                    self.model.contactOriginal.mobilePhoneInput =self.model.contact.mobilePhoneInput;
                    self.model.contactOriginal.mobilePhoneCode =self.model.contact.mobilePhoneCode;
                    if (address) {
                        self.personData.addresses.local = response.data.person.addresses.local;
                        self.model.address = addressFormatter.formatFromService(response.data.person.addresses.local);
                        self.model.displayAddress = addressFormatter.displayForProfile(self.model.address);
                    }
                    self.model.showContactForm = false;
                } else {
                    $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                }
            }).catch(function() {
                $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
            });
        };

        self.model.saveContact = function() {
            self.contactDetailsForm.$submitted = true;
            self.contactform.$submitted = true;
            if (!self.model.contact.mobilePhoneInput || self.model.contact.mobilePhoneInput == ''
                || (self.contactDetailsForm.$invalid && self.contactform.$invalid) || self.model.emailInvalid
                || self.model.emailRequired || self.model.isEmailIDDuplicate) {
                return false;
            } else {
                if (self.model.addressHasChanged()) {
                    self.checkIfValidAddress();
                } else {
                    self.saveContactFormUpdates();
                }
            }
            personalService.scrollToTop('#mobile-contact-details-tab');
        };

        self.model.cancelContact = function() {
            self.model.contact = angular.copy(self.model.contactOriginal);
            self.model.address = addressFormatter.formatFromService(self.personData.addresses.local);
            self.model.isEmailIDDuplicate = false;
            self.credentials.emailComponent.userEmailField =self.model.contact.email;
            if (self.model.contact.mobilePhoneInput) {
                var mobileNumber =self.model.contact.mobilePhoneInput;
                self.model.contact.mobilePhoneInputDisplay = PhoneNumberFormatter
                    .getPhoneDisplayFormat(self.model.contact.mobilePhoneCode, mobileNumber);
                self.credentials.phoneComponent.userPhoneField = mobileNumber;
                self.credentials.phoneComponent.phoneCode =self.model.contact.mobilePhoneCode;
            }
            if (null != self.contactDetailsForm && self.contactDetailsForm != undefined) {
                self.contactDetailsForm.$submitted = false;
                self.contactDetailsForm.$setUntouched();
                self.contactDetailsForm.$setPristine();
            }
            if (null != self.contactform && self.contactform != undefined) {
                self.contactform.$submitted = false;
                self.contactform.$setUntouched();
                self.contactform.$setPristine();
            }
            self.model.showContactForm = false;
            personalService.scrollToTop('#mobile-contact-details-tab');
        };

        self.model.addressHasChanged = function() {
            if (self.contactform.$invalid && self.contactDetailsForm.$invalid) {
                return false;
            }
            var originalAddress = addressFormatter.formatFromService(self.personData.addresses.local);
            if ((originalAddress.streetAddress ==self.model.address.streetAddress)
                && (originalAddress.streetAddress2 ==self.model.address.streetAddress2)
                && (originalAddress.city ==self.model.address.city)
                && (originalAddress.state ==self.model.address.state)
                && (originalAddress.zipcode ==self.model.address.zipcode)
                && (originalAddress.country ==self.model.address.country)) {
                return false;
            } else {
                return true;
            }
        };

        self.checkIfValidAddress = function() {
            self.addressJsonDataForModal = {
                'addressLine1': self.model.address.streetAddress,
                'addressLine2': self.model.address.streetAddress2,
                'city': self.model.address.city,
                'state': self.model.address.state,
                'zip': self.model.address.zipcode
            };
            if (!addressConfigs.qasValidation) {
                self.model.saveAddressOnSuccess(self.addressJsonDataForModal);
            } else {
                qas.callQAS(self.addressJsonDataForModal, $rootScope.qasCallback, accountConfigManager);
            }
        };
        $rootScope.qasCallback = function QAScalled(addresses) {
            self.addressList = [];
            self.suggestionsData = null;
            if (addresses instanceof Array && addresses.length != 0) {
                addresses.forEach(function(item) {
                    var tempAddress = {};
                    try {
                        if (null != item.addressText && undefined != item.addressText) {
                            var addressLines = item.addressText.split(',');
                            var cityStateZip = '';
                            if (addressLines.length == 3) {
                                tempAddress.addressLine1 = addressLines[0];
                                tempAddress.addressLine2 = addressLines[1];
                                cityStateZip = addressLines[2].trim();
                            }
                            if (addressLines.length == 2) {
                                tempAddress.addressLine1 = addressLines[0];
                                cityStateZip = addressLines[1].trim();
                            }

                            switch (self.countryCode) {
                            case 'CA':
                                tempAddress.zip = cityStateZip.substr(cityStateZip.length - 7);
                                var cityState = cityStateZip.substring(0, cityStateZip.length - 7);
                                tempAddress.state = cityState.substring(cityState.length - 2);
                                tempAddress.city = cityState.substring(0, cityState.length - 3);
                                break;
                            case 'AU':
                                tempAddress.zip = cityStateZip.substr(cityStateZip.length - 4);
                                cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                                var cityStateArray = cityStateZip.split(/[\s,]+/);
                                if (cityStateArray.length > 0) {
                                    tempAddress.state = cityStateArray[cityStateArray.length - 1];
                                }
                                tempAddress.city = cityStateZip.substring(0, cityStateZip.lastIndexOf(' '));
                                break;
                            case 'NZ':
                                tempAddress.zip = cityStateZip.substr(cityStateZip.length - 4);
                                cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                                var cityStateArray = cityStateZip.split(/[\s,]+/);
                                if (cityStateArray.length > 0) {
                                    tempAddress.state = cityStateArray[cityStateArray.length - 1];
                                }
                                tempAddress.city = cityStateZip.substring(0, cityStateZip.lastIndexOf(' '));
                                break;
                            default:
                                tempAddress.zip = cityStateZip.trim().match('([0-9]+)(-[0-9]+)?')[0];
                                cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                                tempAddress.state = cityStateZip.substring(cityStateZip.length - 2);
                                tempAddress.city = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.state));
                                break;
                            }
                            self.addressList.push(tempAddress);
                        }
                    } catch (err) {}
                });
                self.invalidAddress = false;
                self.isSaveForAddressClicked = true;
                self.suggestionsData = self.addressList;
                modalPopupInstance(addressValidationModalTemplate, 'addressVerification',
                    'app-modal-window address-verification-popup');
            } else if (addresses == 'InvalidAddress') {
                self.invalidAddress = true;
                self.isSaveForAddressClicked = true;
                modalPopupInstance(addressValidationModalTemplate, 'addressVerification',
                    'app-modal-window address-verification-popup');
            } else if (addresses && addresses instanceof Object) {
                if (addresses.zip != undefined) {
                    self.addressJsonDataForModal.addressLine1 = addresses.lineone
                        ? addresses.lineone.toUpperCase() : '';
                    self.addressJsonDataForModal.addressLine2 = addresses.linetwo
                        ? addresses.linetwo.toUpperCase() : '';
                    self.addressJsonDataForModal.city = addresses.city ? addresses.city.toUpperCase() : '';
                    self.addressJsonDataForModal.state = addresses.state ? addresses.state.toUpperCase() : '';
                    self.addressJsonDataForModal.zip = addresses.zip ? addresses.zip : '';
                    self.model.saveAddressOnSuccess(self.addressJsonDataForModal);
                }
            }
        };

        self.model.saveAddressOnSuccess = function(addressData) {
            var address = {
                streetAddress: addressData.addressLine1,
                city: addressData.city,
                state: addressData.state,
                zipcode: addressData.zip,
                country: self.countryCode
            };
            if (self.model.address.streetAddress2) {
                address.streetAddress2 = addressData.addressLine2;
            } else {
                address.streetAddress2 = '';
            }
            self.saveContactFormUpdates(address);
        };

        self.model.cancelAddress = function() {
            angular.extend(self.model.address, self.model.addressOriginal);
            self.model.showAddressForm = false;
            personalService.scrollToTop();
        };

        /** ************************************************************************************************
         My Profile Contact Details Section
         **************************************************************************************************/

        self.model.changeSwitch = function(flag) {
            self.model.switchValue =self.model.switchValue == 'switchOff' ? 'switchOn' : 'switchOff';
            if (self.model.switchValue == 'switchOn') {
                self.model.loginPref.loginfacebook = 'Yes';
            } else {
                self.model.loginPref.loginfacebook = 'No';
            }
        };

        self.model.editLoginPref = function() {
            self.model.loginPrefOriginal = angular.copy(self.model.loginPref);
            self.passwordCredentials.userEmailField = self.model.loginPref.username;
            self.loginprefform.passwordForm.passwordInput.$setUntouched();
            self.model.showLoginForm = true;
        };

        self.model.saveLoginPref = function() {
            var isEmptyPasswordSubmit = typeof self.passwordCredentials.userPassword === 'undefined' || self.passwordCredentials.userPassword =='';
            if (self.loginprefform.$invalid && !isEmptyPasswordSubmit) {
                self.model.showLoader(true, 5000);
                gigya.accounts.isAvailableLoginID({
                    loginID: self.passwordCredentials.userEmailField,
                    callback: function(data) {
                        var errorComp = angular.element.find('#verifyUsernameAvailable')[0];
                        var errorCompM = angular.element.find('#verifyUsernameAvailableMobile')[0];
                        self.model.emailDuplicateCheckValue=self.passwordCredentials.userEmailField;
                        if (!data.isAvailable && self.passwordCredentials.userEmailField
                            !==self.model.loginPrefOriginal.username) {
                            if (errorComp != null && errorComp != undefined) {
                                errorComp.style.display = 'block';
                            }
                            if (errorCompM != null && errorCompM != undefined) {
                                errorCompM.style.display = 'block';
                            }
                        } else if (data.isAvailable) {
                            if (errorComp != null && errorComp != undefined) {
                                errorComp.style.display = 'none';
                            }
                            if (errorCompM != null && errorCompM != undefined) {
                                errorCompM.style.display = 'none';
                            }
                        }
                        self.loginprefform.passwordForm.passwordInput.$setTouched();

                        self.loginprefform.customLoginForm.userEmailField.$setTouched();
                        return false;
                    }
                });
                return false;
            }

            if (angular.element.find('#verifyUsernameAvailable')[0] != null
                && angular.element.find('#verifyUsernameAvailable')[0] != undefined) {
                angular.element.find('#verifyUsernameAvailable')[0].style.display = 'none';
            }
            if (angular.element.find('#verifyUsernameAvailableMobile')[0] != null
                && angular.element.find('#verifyUsernameAvailableMobile')[0] != undefined) {
                angular.element.find('#verifyUsernameAvailableMobile')[0].style.display = 'none';
            }

            var value = self.passwordCredentials.userEmailField;

            value = value.replace(/[\-()]/g, '');

            self.model.loginPref.username = value;
            self.model.emailDuplicateCheckValue = self.model.loginPref.username;
            gigya.accounts.isAvailableLoginID({
                loginID: self.model.loginPref.username,
                callback: function(data) {
                    var errorComp = angular.element.find('#verifyUsernameAvailable')[0];
                    var errorCompM = angular.element.find('#verifyUsernameAvailableMobile')[0];

                    if (!data.isAvailable && self.model.loginPref.username !==self.model.loginPrefOriginal.username) {
                        if (errorComp != null && errorComp != undefined) {
                            errorComp.style.display = 'block';
                        }
                        if (errorCompM != null && errorCompM != undefined) {
                            errorCompM.style.display = 'block';
                        }
                        // self.model.loginPref.username =self.model.loginPrefOriginal.username;
                        return;
                    }
                    var loginData = {};

                    self.model.loginPref.passwordDisplay = '******';
                    if (self.model.loginPref.loginfacebook == 'Yes') {
                        self.model.switchValue = 'switchOn';
                    } else {
                        self.model.switchValue = 'switchOff';
                    }

                    loginData.loginId =self.model.loginPref.username;
                    loginData.oldLoginId =self.model.loginPrefOriginal.username;
                    loginData.newPassword = self.passwordCredentials.userPassword;
                    loginData.UID = personalService.getGigyaId();
                    var setUserNamePromise = personalService.setLoginPref(loginData);
                    setUserNamePromise.then(function(response) {
                        if (response.status == 200 || response.status == 201) {
                            self.model.contact.email = self.passwordCredentials.userEmailField;
                            var data = {
                                contact: self.model.contact
                            };
                            self.model.updateEmail();
                            var promise = personalService.setContactDetails(data);
                            promise.then(function(response) {
                                if (response.status == 200 || response.status == 201) {
                                    // update detail info
                                    var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
                                    userProfileDetailInfo.profileContactInfo.email =
                                        self.passwordCredentials.userEmailField;
                                    userProfileManager.setUserProfileDetailInfo(userProfileDetailInfo);

                                    cookieUtil.getCookie('basicInfo',
                                        'US-EN-' + self.passwordCredentials.userEmailField, {path: '/'});

                                    // update master info
                                    var userProfileMasterInfo = userProfileManager.getUserProfileMasterInfo();
                                    userProfileMasterInfo.emailId = self.passwordCredentials.userEmailField;
                                    userProfileMasterInfo.username = self.passwordCredentials.userEmailField;
                                    userProfileManager.setUserProfileMasterInfo(userProfileMasterInfo);
                                    self.model.contact.email =self.model.loginPref.username;
                                    self.model.showLoginForm = false;
                                } else {
                                    self.model.contact.email =self.model.loginPrefOriginal.username;
                                    var loginData = {};
                                    loginData.loginId =self.model.loginPrefOriginal.username;
                                    loginData.oldLoginId =self.model.loginPref.username;
                                    loginData.newPassword = self.passwordCredentials.userPassword;
                                    loginData.UID = personalService.getGigyaId();
                                    var setUserNamePromise = personalService.setLoginPref(loginData);
                                    setUserNamePromise.then(function(response) {
                                        if (response.status == 200 || response.status == 201) {
                                            self.passwordCredentials.userEmailField =self.model.loginPrefOriginal.username;
                                            $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                                        }
                                    });
                                }
                            });
                        }
                        self.passwordCredentials.userPassword = null;
                        self.loginprefform.passwordForm.$setUntouched();
                        self.loginprefform.passwordForm.$setPristine();
                        self.passwordCredentials.lowerCaseInPassword='';
                        self.passwordCredentials.upperCaseInPassword='';
                        self.passwordCredentials.numberInPassword='';
                        self.passwordCredentials.specialCharInPassword='';
                        self.passwordCredentials.userPassword = '';
                    });
                }

            });
            personalService.scrollToTop('#mobile-login-pref-tab');
        };

        self.model.cancelLoginPref = function() {
            self.loginprefform.$setPristine();
            self.loginprefform.$setUntouched();
            self.passwordCredentials.userPassword = '';
            self.passwordCredentials.userEmailField = self.model.loginPref.username;
            self.passwordCredentials.lowerCaseInPassword='';
            self.passwordCredentials.upperCaseInPassword='';
            self.passwordCredentials.numberInPassword='';
            self.passwordCredentials.specialCharInPassword='';
            self.passwordCredentials.numberOfConditions=0;
            var errorComp = angular.element.find('#verifyUsernameAvailable')[0];
            if (errorComp != null && errorComp != undefined) {
                errorComp.style.display = 'none';
            }
            var errorCompM = angular.element.find('#verifyUsernameAvailableMobile')[0];
            if (errorCompM != null && errorCompM != undefined) {
                errorCompM.style.display = 'none';
            }
            self.model.loginPref = angular.copy(self.model.loginPrefOriginal);
            self.model.showLoginForm = false;
            personalService.scrollToTop('#mobile-login-pref-tab');
        };

        /** ************************************************************************************************
         My Profile Personal Details Section
         **************************************************************************************************/

        self.model.updateDate = function(input) {
            if (input == 'year') {
                self.model.month = '';
                self.model.day = '';
            } else if (input == 'month') {
                self.model.day = '';
            }
            if (self.model.year && self.model.month && self.model.day) {
                self.model.personalDetails.birthdate = new Date(self.model.year, self.model.month, self.model.day).format(dateFormatting);
            }
        };

        self.model.editPersonalDetails = function() {
            self.model.personalDetailsOriginal = angular.copy(self.model.personalDetails);
            self.model.showPersonalForm = true;
            self.model.showBirthdayError = false;
        };

        self.model.savePersonalDetails = function(formcheck) {
            self.model.isSubmitted = true;
            if ((!self.model.day && !self.model.year && !self.model.month) ||
                (self.model.day == 'DD' && self.model.year == 'YYYY' && self.model.month == 'MM')) {
                self.model.hasError.err = formcheck.$dirty==true?false:true;
                self.model.hasError.message = angular.element('#birthdateerrortext').val();
                angular.element('#berror').addClass('ng-hide');
                return;
            }
            if ((self.model.day && self.model.day != 'DD') && (self.model.month && self.model.month != 'MM') &&
                (self.model.year && self.model.year != 'YYYY')) {
                self.personaldetailsform.$submitted = true;
                self.model.personalDetails.birthdate = moment(self.model.year + '-' +self.model.month + '-' +self.model.day, 'YYYY-M-D')
                    .format('YYYY-MM-DD');
                var selectedDate = new Date(self.model.year, self.model.month - 1, self.model.day);
                if (selectedDate > self.validAgeDate) {
                    return;
                }

                // process date object to store in string format

                var promise = personalService.setPersonalDetails(self.model.personalDetails);
                promise.then(function(status) {
                    if (status == 200 || status == 201) {
                        self.model.showPersonalForm = false;
                        self.model.personalDetails.birthdate = moment(self.model.day + '-' +self.model.month
                            + '-' +self.model.year, 'D-M-YYYY').format(dateFormatting);
                        self.model.originalBirthdate = {
                            year: self.model.year,
                            month: self.model.month,
                            day: self.model.day
                        };
                    } else {
                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                    }
                });
            }
            personalService.scrollToTop('#mobile-personal-details-tab');
        };

        self.model.cancelPersonalDetails = function(formcheck) {
            self.model.isSubmitted = false;
            self.model.hasError.err = false;
            if (formcheck) {
                formcheck.$dirty=false;
                formcheck.birthdayForm.$setPristine();
            }
            angular.element(document).find('select').removeClass('red-border');
            var date =self.model.originalBirthdate;
            if (date.day && date.month && date.year) {
                self.model.personalDetails.birthdate = moment(date.day + '-' + date.month + '-'
                    + date.year, 'D-M-YYYY').format(dateFormatting);
                self.model.personalDetailsOriginal.birthdate = moment(date.day + '-' + date.month + '-'
                    + date.year, 'D-M-YYYY').format(dateFormatting);
            }
            self.model.day = date.day ? date.day : 'DD';
            if (date.month == 0) {
                self.model.month = 1;
            } else {
                self.model.month = date.month ? date.month : 'MM';
            }
            self.model.year = date.year ? date.year : 'YYYY';
            self.model.personalDetails = angular.copy(self.model.personalDetailsOriginal);
            angular.element('#berror').addClass('ng-hide');
            self.model.showPersonalForm = false;
            self.model.showBirthdayError = false;
            personalService.scrollToTop('#mobile-personal-details-tab');
        };

        self.model.checkIfCharPressed = function($event) {
            var keycode = $event.which || $event.keyCode;
            if (keycode === 101) {
                $event.preventDefault();
            }
        };

        self.model.checkMail = function() {
            var emailInput = self.contactform.email.$modelValue;
            // eslint-disable-next-line max-len
            var patternForemail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var emailvalidflag = patternForemail.test(emailInput);


            if (emailInput === undefined || emailInput === '') {
                self.model.emailRequired = true;
                self.model.emailInvalid = false;
                return;
            }

            if (emailInput !== undefined) {
                if (emailInput !== '') {
                    self.model.emailInvalid = !emailvalidflag;
                    self.model.emailRequired = false;
                }
            }
        };

        self.model.findItemById = function(id, arrayToBeProcessed, flag) {
            var returnItem;
            angular.forEach(arrayToBeProcessed, function(value, key) {
                if (flag == 'C') {
                    if (value.code == id) {
                        returnItem = value.name;
                    }
                } else {
                    if (value.id == id) {
                        if (flag == 'I') {
                            returnItem = key;
                        } else {
                            returnItem = value;
                        }
                    }
                }
            });
            return returnItem;
        };

        /** ************************************************************************************************
         My Profile Family Accounts Section
         **************************************************************************************************/

        var addFamilyModalTemplate = 'modalfamily.html';

        self.model.addFamily = function() {
            modalPopupInstance(addFamilyModalTemplate, 'addFamily',
                'app-modal-window add-family-popup personal-section-popup');
        };

        self.model.editFamily = function() {
            self.model.familyListCopy = angular.copy(self.model.familyList);
            self.model.showEditStateFamily = true;
        };

        self.model.deleteFamily = function(id) {
            var deleteIndex =self.model.findItemById(id, self.model.familyList, 'I');
            self.model.deleteFamilyList.push(self.model.familyList[deleteIndex]);
            self.model.familyList.splice(deleteIndex, 1);
        };

        self.model.saveDeleteFamily = function() {
            self.editfamilyForm.$submitted = true;
            personalService.saveDeleteFamily(self.model.deleteFamilyList);
            self.model.familyListCopy = angular.copy(self.model.familyList);
            self.model.showEditStateFamily = false;
        };

        self.model.cancelDeleteFamily = function() {
            self.model.familyList = angular.copy(self.model.familyListCopy);
            self.model.showEditStateFamily = false;
        };

        self.goToUrl = function(dest) {
            if (dest) {
                $window.location = commonUtil.constructFullUrl(dest);
            }
        };

        var modalPopupInstance = function(modalTemplateVariable,
            controller,
            windowClass,
            isCropModal,
            croppedImg,
            editProfileCachedData) {
            if (controller == 'addFamily') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};

                        modalSelf.emailValue = true;
                        modalSelf.mobilePhoneValue = false;
                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                        };
                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };
                        modalSelf.sendInvite = function(isValid) {
                            if (!isValid) {
                                return;
                            }

                            modalSelf.credentials.isSubmitted = isValid;
                            var errorComp = angular.element.find('#verifyUsernameAvailableFamily')[0];
                            gigya.accounts.isAvailableLoginID({
                                loginID: modalSelf.model.credentials.userEmailField,
                                callback: function(data) {
                                    if (!data.isAvailable) {
                                        if (errorComp != null && errorComp != undefined) {
                                            errorComp.style.display = 'block';
                                        }
                                    } else {
                                        if (isValid) {
                                            modalSelf.model.email = modalSelf.model.credentials.userEmailField;
                                            var emailId = modalSelf.model.credentials.userEmailField;
                                            var templateUrl = templateurl;
                                            if (templateurl.indexOf('http') !== 0) {
                                                templateUrl = $window.location.protocol + '//'
                                                    + $window.location.host + templateurl + '.html';
                                            }
                                            self.popupModel = modalSelf.model;
                                            var promise = personalService.updateMember(modalSelf.model,
                                                USER_TYPE.FAMILY_MEMBER);

                                            promise.then(function(data) {
                                                // for demo purpose
                                                var guid = data.data.invitationGuid;
                                                var emailPromise = personalService.sendEmailInvite(emailId,
                                                    data.data.invitationGuid, templateUrl, userProfileManager
                                                        .getUserProfileMasterInfo().userId, self.popupModel);
                                                emailPromise.then(function(data) {
                                                    self.model.familyList = self.model.familyList
                                                        ? self.model.familyList : [];
                                                    self.model.familyList.push({
                                                        'id': (self.model.familyList.length - 1),
                                                        'firstname': modalSelf.model.firstname,
                                                        'lastname': modalSelf.model.lastname,
                                                        'accountstatus': 'ACCOUNT PENDING',
                                                        'invitationGuId': guid,
                                                        'contactpreference': {
                                                            'email': modalSelf.model.email,
                                                            'phone': modalSelf.model.phone,
                                                            'contactpref': modalSelf.model.contactpref
                                                        },
                                                        'inviteStatus': [{
                                                            'id': 101,
                                                            'status': true,
                                                            'name': 'sent',
                                                            'label': 'Resend Invite'
                                                        }]
                                                    });
                                                    modalSelf.ok();
                                                });
                                            });
                                        }
                                    }
                                }
                            });
                        };

                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            } else

            if (controller == 'editProfile') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', 'cropModalEvent', 'croppedImgData', 'editFormModel', '$scope',
                        function($uibModalInstance, cropModalEvent, croppedImgData, editFormModel, $scope) {
                            var modalSelf = this;
                            modalSelf.sizeLimit = 2; // 2MB is the size limit
                            self.model.userdata.profileImage = self.model.headerInfo.profilePictureUrl;
                            self.model.userdata.firstname = self.model.headerInfo.firstName;
                            self.model.userdata.lastname = self.model.headerInfo.lastName;
                            self.model.userdata.preferredname = self.model.headerInfo.preferredname;
                            self.model.userdata.fullName = self.model.headerInfo.fullName;
                            modalSelf.uploadedImageBlob = null;
                            var accountType = [];
                            var accountTypeobj =self.model.userdata && self.model.userdata.accountType
                                ? $filter('filter')(self.model.userdata.accountType, {status: true})[0] : null;
                            accountType.push(accountTypeobj);

                            modalSelf.model = {
                                'profileImage': self.model.headerInfo.profilePictureUrl
                                    ? self.model.headerInfo.profilePictureUrl : null,
                                'defaultthumbnailURL': self.model.headerInfo.defaultthumbnailURL
                                    ? self.model.headerInfo.defaultthumbnailURL : null,
                                'accountType': accountType
                            };

                            $uibModalInstance.rendered.then(function(data) {
                                if (croppedImgData) {
                                    modalSelf.model.profileImage = croppedImgData;
                                } else {
                                    if (editFormModel) {
                                        modalSelf.model.profileImage = editFormModel.profileImage;
                                    } else {
                                        modalSelf.model.profileImage = self.model.headerInfo.profilePictureUrl;
                                    }
                                }
                                if (editFormModel) {
                                    modalSelf.model.firstname = editFormModel.firstname;
                                    modalSelf.model.lastname = editFormModel.lastname;
                                    modalSelf.model.preferredname = editFormModel.preferredname;
                                } else {
                                    modalSelf.model.firstname = self.model.headerInfo.firstName;
                                    modalSelf.model.lastname = self.model.headerInfo.lastName;
                                    modalSelf.model.preferredname =self.model.headerInfo.preferredName;
                                }
                                // $scope.$apply(); - Commented as part of MEC-22294
                            }, function(err) {
                                // eslint-disable-next-line no-console
                                console.info(err);
                            });

                            modalSelf.ok = function() {
                                $uibModalInstance.close();
                            };

                            modalSelf.cancel = function() {
                                $uibModalInstance.dismiss();
                            };

                            modalSelf.uploadFiles = function(files) {
                                var arrayOfFiles;
                                if (files instanceof Array) {
                                    modalSelf.Files = files;
                                    arrayOfFiles = files;
                                } else {
                                    arrayOfFiles = [];
                                    arrayOfFiles.push(files);
                                    modalSelf.Files = arrayOfFiles;
                                }

                                modalSelf.sizeLimitError = modalSelf.files && modalSelf.files.size
                                    && (modalSelf.files.size / 1048576) > modalSelf.sizeLimit ? true : false;

                                if (!modalSelf.sizeLimitError) {
                                    // Upload Image
                                    var fileUploadPromise = personalService.uploadPhoto(files);
                                    fileUploadPromise.then(function(response) {
                                        modalSelf.uploadedImageBlob = response;
                                        modalSelf.editFormModel = {};
                                        modalSelf.editFormModel['firstname'] = modalSelf.model.firstname;
                                        modalSelf.editFormModel['lastname'] = modalSelf.model.lastname;
                                        modalSelf.editFormModel['preferredname'] = modalSelf.model.preferredname;
                                        modalSelf.editFormModel['profileImage'] = modalSelf.model.profileImage;
                                        $uibModalInstance.dismiss();

                                        showPictureCropModal(true, response, modalSelf.editFormModel);
                                    });
                                }
                            };

                            modalSelf.removeProfilePhoto = function() {
                                croppedImgData = modalSelf.model.profileImage = null;
                            };

                            modalSelf.updateProfilePic = function(response) {
                                if (response.profile) {
                                    modalSelf.model.profileImage = self.model.headerInfo.thumbnailURL
                                        = $rootScope.accImage = response.profile.thumbnailURL;
                                    self.model.headerInfo.profilePictureUrl = response.profile.photoURL;
                                    var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
                                    userProfileDetailInfo.profileHeader.profileThumbnailUrl =
                                        modalSelf.model.profileImage;
                                    userProfileManager.setUserProfileDetailInfo(userProfileDetailInfo);
                                } else if (response.indexOf('gigya') !== -1) {
                                    self.model.headerInfo.profilePictureUrl = modalSelf.model.profileImage =
                                        self.model.headerInfo.thumbnailURL = $rootScope.accImage = response;
                                } else {
                                    self.model.headerInfo.profilePictureUrl = modalSelf.model.profileImage =
                                        self.model.headerInfo.thumbnailURL = '';
                                    $rootScope.accImage = '';
                                }
                                modalSelf.updateProfileInHybris();
                            };

                            modalSelf.updateProfileInHybris = function() {
                                var hybrisCallPromise = personalService.setHeaderInfoHybris(modalSelf.model);
                                hybrisCallPromise.then(function(status) {
                                    if (status == 200 || status == 201) {
                                        self.model.headerInfo.firstName = modalSelf.model.firstname;
                                        self.model.headerInfo.lastName = modalSelf.model.lastname;
                                        self.model.headerInfo.preferredName = modalSelf.model.preferredname;
                                        // Close Modal Window

                                        $uibModalInstance.close();
                                    } else {
                                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                                    }
                                });
                            };

                            modalSelf.saveFileUpload = function(isValid) {
                                if (isValid) {
                                    // Update form fields
                                    if (modalSelf.model.preferredname != null && modalSelf.model.preferredname
                                        != undefined && modalSelf.model.preferredname != '') {
                                        self.model.isPreferredNamePresent = true;
                                        self.model.headerInfo.fullName= modalSelf.model.preferredname;
                                    } else {
                                        self.model.isPreferredNamePresent = false;
                                        self.model.headerInfo.fullName= modalSelf.model.firstname +' '
                                            + modalSelf.model.lastname;
                                    }
                                    modalSelf.model.firstname = modalSelf.model.firstname
                                        ? modalSelf.model.firstname : '';
                                    modalSelf.model.lastname = modalSelf.model.lastname
                                        ? modalSelf.model.lastname : '';
                                    modalSelf.model.preferredname = modalSelf.model.preferredname
                                        ? modalSelf.model.preferredname : '';

                                    // Check if user has uploaded a profile picture
                                    if (croppedImgData) {
                                        // Save Profile Picture to Gigya
                                        self.model.showLoader(true, 15000);
                                        var fileUploadToGigyaPromise = personalService
                                            .uploadPhotoToGigya(croppedImgData);
                                        fileUploadToGigyaPromise.then(function(response) {
                                            modalSelf.uploadRemoveErrorResponse = null;
                                            if (response.status == 'OK') {
                                                // Update Profile Picture
                                                gigya.accounts.getAccountInfo({callback: modalSelf.updateProfilePic});
                                            } else {
                                                // console.info('Error uploading image files to Gigya.');
                                            }
                                        });
                                    } else {
                                        if (modalSelf.model.profileImage) {
                                            modalSelf.updateProfilePic(modalSelf.model.profileImage);
                                        } else {
                                            modalSelf.updateProfilePic(modalSelf.model.defaultthumbnailURL);
                                        }
                                    }

                                    // Update User Profile Manager
                                    var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
                                    userProfileDetailInfo.profileHeader.firstName = modalSelf.model.firstname;
                                    userProfileDetailInfo.profileHeader.lastName = modalSelf.model.lastname;
                                    userProfileDetailInfo.profileHeader.preferredName = modalSelf.model.preferredname;
                                    userProfileDetailInfo.profileHeader.profileThumbnailUrl =
                                        modalSelf.model.profileImage;
                                    userProfileManager.setUserProfileDetailInfo(userProfileDetailInfo);

                                    // Update Root Scope
                                    $rootScope.firstName = modalSelf.model.firstname;
                                    $rootScope.lastName = modalSelf.model.lastname;
                                    $rootScope.preferredName = modalSelf.model.preferredname;
                                }
                            };

                            $scope.$on('$locationChangeStart', function($event) {
                                $uibModalInstance.dismiss();
                            });
                        }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass,
                    resolve: {
                        cropModalEvent: function() {
                            return (isCropModal) ? true : false;
                        },
                        croppedImgData: function() {
                            return croppedImg;
                        },
                        editFormModel: function() {
                            return editProfileCachedData;
                        }
                    }
                });

                modalInstance.result.then(function(data) {
                    // eslint-disable-next-line no-console
                    console.info('then', data);
                }, function(data) {
                    // eslint-disable-next-line no-console
                    console.info('error', data);
                });
            }
            if (controller == 'addressVerification') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};
                        modalSelf.model.addressList = self.addressList;
                        modalSelf.addressData = self.addressJsonDataForModal;
                        modalSelf.suggestionsData = self.suggestionsData;
                        modalSelf.invalidAddress = self.invalidAddress;

                        modalSelf.ok = function() {
                            personalService.scrollToTop('#mobile-contact-details-tab');
                            $uibModalInstance.close();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };

                        modalSelf.goBackAndEdit = function() {
                            modalSelf.cancel();
                        };

                        modalSelf.goWithSelectedAddress = function(isValid, selectedObject) {
                            if (isValid) {
                                modalSelf.useEnteredAddress(selectedObject);
                            }
                        };

                        modalSelf.useEnteredAddress = function(addressDataObj) {
                            modalSelf.finalAddressData = addressDataObj ? addressDataObj : self.addressJsonDataForModal;
                            self.model.saveAddressOnSuccess(modalSelf.finalAddressData);
                            modalSelf.ok();
                        };

                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            }

            if (controller == 'emailVerification') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', 'personalService', '$scope',
                        function($uibModalInstance, personalService, $scope) {
                            var modalSelf = this;
                            var hiddenEmailLength = 17;
                            modalSelf.isChangeUsername = self.isChangeUsername;


                            modalSelf.ok = function() {
                                $uibModalInstance.close();
                            };

                            modalSelf.cancel = function() {
                                $uibModalInstance.dismiss();
                            };

                            modalSelf.parentPageEmailUsernameVerification = self.parentPageEmailUsernameVerification;
                            modalSelf.resendemailpopupHeader = self.resendemailpopupHeader;
                            modalSelf.resendemailpopupBeforeEmail = self.resendemailpopupBeforeEmail;
                            modalSelf.resendemailpopupAfterEmail = self.resendemailpopupAfterEmail;
                            modalSelf.resendemailpopupBeforePhone = self.resendemailpopupBeforePhone;
                            modalSelf.resendemailpopupPhone = self.resendemailpopupPhone;
                            modalSelf.resendemailpopupAfterPhone = self.resendemailpopupAfterPhone;
                            modalSelf.resendemailpopupResendButton = self.resendemailpopupResendButton;

                            modalSelf.phone = '1-800-487-1000';
                            var email = self.model.loginPref.username;
                            if (email) {
                                var privacyEmail = email.substr(0, email.indexOf('@'));
                                modalSelf.emailAddress = privacyEmail.substr(0, 2);
                                for (var i = 2; i < ((privacyEmail.length <= hiddenEmailLength)
                                    ? privacyEmail.length : hiddenEmailLength); i++) {
                                    modalSelf.emailAddress += '*';
                                }
                                modalSelf.emailAddress += email.substr(email.indexOf('@'));
                            }

                            modalSelf.closeAndInvokeSave = function() {
                                modalSelf.cancel();
                            };

                            modalSelf.resendEmail = function() {
                                var data = {};
                                data.sendToEmail = self.model.loginPref.username;
                                personalService.sendUserNameVerificationEmail(data);
                                modalSelf.ok();
                            };

                            $scope.$on('$locationChangeStart', function($event) {
                                $uibModalInstance.dismiss();
                            });
                        }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            }
        };


        /** ************************************************************************************************
         My Profile Privacy Preferences Section
         **************************************************************************************************/

        var loadPrivacyPreferences = function() {
            self.model.privacy = privacyPreferenceConfigs.getDefaultPrivacyPreferences(accountConfigManager);
        };

        self.model.editPrivacy = function() {
            self.model.privacyOriginal = angular.copy(self.model.privacy);
            self.model.showPrivacyForm = true;
        };

        self.model.savePrivacyPref = function() {
            self.privacyform.$submitted = true;
            var hybrisCallPromise = personalService.savePrivacyPref(self.model.privacy);
            hybrisCallPromise.then(function(status) {
                if (status == 200 || status == 201) {
                    self.model.showPrivacyForm = false;
                } else {
                    $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                }
            });
            personalService.scrollToTop('#mobile-privacy-pref-tab');
        };

        self.model.cancelPrivacyPref = function() {
            self.model.privacy = angular.copy(self.model.privacyOriginal);
            self.model.showPrivacyForm = false;
            updatePrivacyPreferenceAttributes(self.model.privacy);
            personalService.scrollToTop('#mobile-privacy-pref-tab');
        };
        self.model.redirectToDistributorConversion = function(url) {
            userProfileManager.setCustomerConvertionReturnURL($window.location.href);
            self.showBusinessDistributorForm = true;

            $window.location = commonUtil.constructFullUrl(url);
        };

        /** ************************************************************************************************
         My Profile Shipping Preferences Section
         **************************************************************************************************/


        self.model.loadShippingForm = function(isAdd, id) {
            self.model.showShippingForm = true;
            if (isAdd) {
                self.model.isAddShipping = true;
                self.model.currentshipping = {};
                self.shippingform.$submitted = false;
            } else {
                self.model.isAddShipping = false;
                self.model.currentshipping =self.model.findItemById(id, self.model.shipping);
                angular.extend(self.model.currentshippingOrg, self.model.currentshipping);
            }
        };

        self.model.getActiveBusinessAccount = function(dataModel) {
            var activeAccount = $filter('filter')(dataModel, {
                status: true
            })[0];
            return activeAccount;
        };

        self.model.stopNumbers = function(event) {
            var keycode = event.which || event.keyCode;
            if ((keycode > 48 && keycode < 57) || (keycode === 189)) {
                // do nothing
            } else {
                event.preventDefault();
            }
        };

        self.model.findItemById = function(id, arrayToBeProcessed, flag) {
            var returnItem;
            angular.forEach(arrayToBeProcessed, function(value, key) {
                if (flag == 'C') {
                    if (value.code == id) {
                        returnItem = value.name;
                    }
                } else {
                    if (value.id == id) {
                        if (flag == 'I') {
                            returnItem = key;
                        } else {
                            returnItem = value;
                        }
                    }
                }
            });
            return returnItem;
        };

        self.model.saveShipping = function() {
            self.shippingform.$submitted = true;
            if (self.model.isAddShipping) {
                self.model.currentshipping.country = 'US';
                if (self.model.currentshipping.isprimary) {
                    angular.forEach(self.model.shipping, function(value) {
                        value.isprimary = false;
                    });
                }
                var titleCode;
                if (self.model.personalDetails.gender == 'MALE') {
                    titleCode = 'mr';
                } else {
                    titleCode = 'ms';
                }
                self.model.currentshipping.titleCode = titleCode;
                var hybrisCallPromise = personalService.addShippingAddress(self.model.currentshipping);
                hybrisCallPromise.then(function(status) {
                    if (status == 200 || status == 201) {
                        self.model.shipping.push(self.model.currentshipping);
                        self.model.showShippingForm = false;
                    } else {
                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                    }
                });
            } else {
                if (self.model.currentshipping.isprimary) {
                    angular.forEach(self.model.shipping, function(value) {
                        if (value.id !=self.model.currentshipping.id) {
                            value.isprimary = false;
                        }
                    });
                }

                var hybrisCallPromise = personalService.updateShippingAddress(self.model.currentshipping);
                hybrisCallPromise.then(function(status) {
                    if (status == 200 || status == 201) {
                        var shippingIndex =self.model.findItemById(self.model.currentshipping.id,
                            self.model.shipping, 'I');
                        self.model.shipping[shippingIndex] =self.model.currentshipping;
                        self.model.showShippingForm = false;
                    } else {
                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                    }
                });
            }
        };

        self.model.cancelShipping = function() {
            angular.extend(self.model.currentshipping, self.model.currentshippingOrg);
            var shippingIndex =self.model.findItemById(self.model.currentshipping.id, self.model.shipping, 'I');
            self.model.shipping[shippingIndex] =self.model.currentshipping;
            self.model.showShippingForm = false;
        };

        /** ************************************************************************************************
         My Profile Addresses Section
         **************************************************************************************************/
        self.model.editAddresses = function() {
            self.model.showAddressesForm = true;
        };
        self.model.cancelAddresses = function() {
            self.model.showAddressesForm = false;
            personalService.scrollToTop('#mobile-addresses-tab');
        };

        /** ************************************************************************************************
         My Profile Billing Preferences Section
         **************************************************************************************************/

        self.model.loadBillingForm = function(isAdd, id) {
            self.billingform.isPrimaryAndExpired = false;
            self.model.showBillingForm = true;
            self.model.currentbilling.regExp = '/^[0-9]{1,19}$/';

            if (isAdd) {
                self.model.isAddBilling = true;
                self.model.currentbilling = {};
                self.billingform.$submitted = false;
            } else {
                self.model.isAddBilling = false;
                self.model.currentbilling =self.model.findItemById(id, self.model.billing);
                angular.extend(self.model.currentbillingOrg, self.model.currentbilling);
                self.model.detectCardType(self.model.currentbilling.cardnumber.toString());
            }
        };

        self.model.saveBilling = function() {
            self.billingform.$submitted = true;
            if (self.billingform.$invalid) {
                return;
            }

            if (self.model.isAddBilling) {
                self.model.currentbilling.country = 'US';
            }

            var ccNumberString =self.model.currentbilling.cardnumberBinded.split('-').join('');
            if (ccNumberString) {
                self.model.currentbilling.cardnumber = parseInt(ccNumberString);
            }
            self.model.currentbilling.ccNumberLastFour = ccNumberString.substr(ccNumberString.length - 4);

            if (self.model.currentbilling.cardtype == '' || self.model.currentbilling.cardtype == undefined) {
                if (self.model.currentbilling.ccTypeDetected == 'V') {
                    self.model.currentbilling.cardtype = 'VISA';
                } else if (self.model.currentbilling.ccTypeDetected == 'M') {
                    self.model.currentbilling.cardtype = 'MASTER';
                } else if (self.model.currentbilling.ccTypeDetected == 'A') {
                    self.model.currentbilling.cardtype = 'AMEX';
                } else if (self.model.currentbilling.ccTypeDetected == 'D') {
                    self.model.currentbilling.cardtype = 'DISCOVER';
                } else {
                    self.model.currentbilling.cardtype = 'OTHER';
                }
            }

            // card is expired or not
            // mm/yy format
            var expmonth =self.model.currentbilling.cardexpiry.substring(0, 2);
            // prepending with 20 by assuming that the year stored is grater than year 2000
            var expyear = '20' +self.model.currentbilling.cardexpiry.substring(2, 4);
            if (self.model.currentbilling.cardexpiry.indexOf('/') !== -1) {
                expyear = '20' +self.model.currentbilling.cardexpiry.substring(3, 5);
                self.model.currentbilling.expiryDisplay =self.model.currentbilling.cardexpiry;
            } else {
                self.model.currentbilling.expiryDisplay = expmonth + '/' +self.model.currentbilling.cardexpiry.substring(2, 4);
            }
            var expdate = new Date(expyear, expmonth, 1);
            if (expdate < new Date()) {
                self.model.currentbilling.isexpired = true;
            } else {
                self.model.currentbilling.isexpired = false;
            }
            if (self.model.currentbilling.isexpired == true && self.model.currentbilling.isprimary == true) {
                self.billingform.isPrimaryAndExpired = true;
                return;
            }

            var billingIndex =self.model.findItemById(self.model.currentbilling.id, self.model.billing, 'I');
            if (self.model.currentbilling.isprimary) {
                angular.forEach(self.model.billing, function(value, key) {
                    if (key !== billingIndex) {
                        value.isprimary = false;
                    }
                });
            }

            // fetch the image as per card type
            if (self.model.currentbilling.cardtype.toUpperCase() == 'VISA') {
                self.model.currentbilling.ccImg = '/etc/clientlibs/mecommerce/core/main/css/' +
                    'src/assets/images/css/v-i-s-a.png';
            } else if (self.model.currentbilling.cardtype.toUpperCase() == 'MASTER') {
                self.model.currentbilling.ccImg = '/etc/clientlibs/mecommerce/core/main/css/' +
                    'src/assets/images/css/m-a-s-t-e-r-c-a-r-d.png';
            } else if (self.model.currentbilling.cardtype.toUpperCase() == 'AMEX') {
                self.model.currentbilling.ccImg = '/etc/clientlibs/mecommerce/core/main/css/' +
                    'src/assets/images/css/a-m-e-x.png';
            } else if (self.model.currentbilling.cardtype.toUpperCase() == 'DISCOVER') {
                self.model.currentbilling.ccImg = '/etc/clientlibs/mecommerce/core/main/css/' +
                    'src/assets/images/css/d-i-s-c-o-v-e-r.png';
            }

            // assign the pattern for ng-pattern for credit card number
            self.model.currentbilling.regExp = '/^[0-9]{1,16}$/';

            if (self.model.isAddBilling) {
                var titleCode;
                if (self.model.personalDetails.gender == 'MALE') {
                    titleCode = 'mr';
                } else {
                    titleCode = 'ms';
                }
                self.model.currentbilling.titleCode = titleCode;
                var hybrisCallPromise = personalService.addBillingInformation(self.model.currentbilling);
                hybrisCallPromise.then(function(status) {
                    if (status == 200 || status == 201) {
                        self.model.billing.push(self.model.currentbilling);
                        self.model.showBillingForm = false;
                    } else {
                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                    }
                });
            } else {
                var hybrisCallPromise = personalService.updateBillingInformation(self.model.currentbilling);
                hybrisCallPromise.then(function(status) {
                    if (status == 200 || status == 201) {
                        self.model.billing[billingIndex] =self.model.currentbilling;
                        self.model.showBillingForm = false;
                    } else {
                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                    }
                });
            }
        };

        self.model.cancelBilling = function() {
            angular.extend(self.model.currentbilling, self.model.currentbillingOrg);
            var billingIndex =self.model.findItemById(self.model.currentbilling.id, self.model.billing, 'I');
            self.model.billing[billingIndex] =self.model.currentbilling;
            self.model.showBillingForm = false;
        };

        /** ************************************************************************************************
         My Profile Communication Preferences Section
         **************************************************************************************************/

        self.model.editCommunication = function() {
            angular.extend(self.model.communicationOriginal, self.model.communication);
            self.model.showComForm = true;
        };

        self.model.saveCommunication = function() {
            self.communicationform.$submitted = true;
            if (self.model.communication.emailIsOpted) {
                self.model.communication.contactpref =self.model.communication.textIsOpted
                    ? emailLabel + ', ' + textLabel : emailLabel;
            } else {
                self.model.communication.contactpref =self.model.communication.textIsOpted ? textLabel : notSpecifiedLabel;
            }
            if (self.model.communication.dnd) {
                self.model.communication.dndDisplay = 'No';
            } else {
                self.model.communication.dndDisplay = 'Yes';
            }
            self.model.communication.languageprefDisplay =self.model.findItemById(self.model.communication.languagepref,
                self.model.languageList, 'C');

            var hybrisCallPromise = personalService.saveCommunication(self.model.communication,
                strings.get('tdc_commemailtext'));
            hybrisCallPromise.then(function(status) {
                if (status == 200 || status == 201) {
                    self.model.langPref =self.model.communicationOriginal.languagepref;
                    angular.extend(self.model.communicationOriginal, self.model.communication);
                    self.model.showComForm = false;
                    var commTab = '?loadTab=communication';

                    if (self.model.communication.languagepref.toLowerCase() !== self.model.langPref.toLowerCase()) {
                        var newLanguage =self.model.communication.languagepref.toLowerCase();
                        var url = localeUtil.replaceUrlLocale(window.location.href, self.countryCode, newLanguage);

                        if (window.location.search.length > 0) {
                            $window.location.href = url;
                        } else {
                            $window.location.href = url.slice(0, url.lastIndexOf('#')) + commTab
                                + url.slice(url.lastIndexOf('#'), url.length);
                        }
                    }
                } else {
                    $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                }
            });
            personalService.scrollToTop('#mobile-comm-pref-tab');
        };

        self.model.cancelCommunication = function() {
            angular.extend(self.model.communication, self.model.communicationOriginal);
            updateEmailCheckboxAttribute(self.model.communication.emailIsOpted);
            updateTextCheckboxAttribute(self.model.communication.textIsOpted);

            self.model.showComForm = false;
            personalService.scrollToTop('#mobile-comm-pref-tab');
        };


        var updateEmailCheckboxAttribute = function(checked) {
            if (checked) {
                document.getElementById('desktop-personal-email').setAttribute('checked', '');
                document.getElementById('mobile-personal-email').setAttribute('checked', '');
            } else {
                document.getElementById('desktop-personal-email').removeAttribute('checked');
                document.getElementById('mobile-personal-email').removeAttribute('checked');
            }
        };

        var updateTextCheckboxAttribute = function(checked) {
            if (checked) {
                document.getElementById('desktop-personal-text').setAttribute('checked', '');
                document.getElementById('mobile-personal-text').setAttribute('checked', '');
            } else {
                document.getElementById('desktop-personal-text').removeAttribute('checked');
                document.getElementById('mobile-personal-text').removeAttribute('checked');
            }
        };

        var updateContactInfoAttribute = function(checked) {
            if (checked) {
                document.getElementById('mobile-contactcheck1').setAttribute('checked', '');
                document.getElementById('desktop-contactcheck1').setAttribute('checked', '');
            } else {
                document.getElementById('mobile-contactcheck1').removeAttribute('checked');
                document.getElementById('desktop-contactcheck1').removeAttribute('checked');
            }
        };

        var updateContactInfoToUplineAttribute = function(checked) {
            if (checked) {
                document.getElementById('mobile-contactcheck2').setAttribute('checked', '');
                document.getElementById('desktop-contactcheck2').setAttribute('checked', '');
            } else {
                document.getElementById('mobile-contactcheck2').removeAttribute('checked');
                document.getElementById('desktop-contactcheck2').removeAttribute('checked');
            }
        };

        var updateContactInfoToFamilyAttribute = function(checked) {
            if (checked) {
                document.getElementById('mobile-contactcheck3').setAttribute('checked', '');
                document.getElementById('desktop-contactcheck3').setAttribute('checked', '');
            } else {
                document.getElementById('mobile-contactcheck3').removeAttribute('checked');
                document.getElementById('desktop-contactcheck3').removeAttribute('checked');
            }
        };

        var updateVisibleInSponsorSearchAttribute = function(checked) {
            if (checked) {
                document.getElementById('mobile-contactcheck4').setAttribute('checked', '');
                document.getElementById('desktop-contactcheck4').setAttribute('checked', '');
            } else {
                document.getElementById('mobile-contactcheck4').removeAttribute('checked');
                document.getElementById('desktop-contactcheck4').removeAttribute('checked');
            }
        };

        var updatePrivacyPreferenceAttributes = function(preferences) {
            updateContactInfoAttribute(preferences.showContactInfoChecked);
            updateContactInfoToUplineAttribute(preferences.showContactInfoToUplineChecked);
            updateContactInfoToFamilyAttribute(preferences.showContactInfoToFamilyChecked);
            updateVisibleInSponsorSearchAttribute(preferences.visibleInSponsorSearchChecked);
        };

        /** ************************************************************************************************
         Payments Section
         **************************************************************************************************/

        self.model.cancelPayments = function() {
            self.model.showPaymentsForm = false;
            personalService.scrollToTop('#mobile-payments-tab');
        };

        /** ************************************************************************************************
         My Profile Utility Methods
         **************************************************************************************************/

        self.model.detectCardType = function(ccNumber) {
            if (!ccNumber) {
                if (self.model.currentbilling.cardnumberBinded != undefined && self.model.currentbilling.cardnumberBinded != '') {
                    var ccNumber =self.model.currentbilling.cardnumberBinded.replace(/-/g, '');
                    self.model.currentbilling.cardnumberBinded =self.model.chunk(ccNumber, 4).join('-');
                }
            } else {
                self.model.currentbilling.cardnumberBinded =self.model.chunk(ccNumber, 4).join('-');
            }

            if ((ccNumber == '') || (ccNumber == undefined)) {
                self.model.currentbilling.ccTypeDetected = 'O';
            } else {
                // visa
                var re = new RegExp('^4');
                if (ccNumber.match(re) != null) {}
                self.model.currentbilling.ccTypeDetected = 'V';

                // Mastercard
                re = new RegExp('^5[1-5]');
                if (ccNumber.match(re) != null) {
                    self.model.currentbilling.ccTypeDetected = 'M';
                }

                // AMEX
                re = new RegExp('^3[47]');
                if (ccNumber.match(re) != null) {
                    self.model.currentbilling.ccTypeDetected = 'A';
                }

                // Discover
                re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)');
                if (ccNumber.match(re) != null) {
                    self.model.currentbilling.ccTypeDetected = 'D';
                }
            }
        };
        self.model.chunk = function(str, n) {
            var ret = [];
            var i;
            var len;

            for (i = 0, len = str.length; i < len; i += n) {
                ret.push(str.substr(i, n));
            }

            return ret;
        };
        self.model.readMoreStorySection = function() {
            self.model.readmorestory = true;
            self.model.story.content = self.handleMBSScriptTexts();
        };

        self.model.readLessStorySection = function() {
            self.model.readmorestory = false;
            self.model.story.content = self.modifyCustomText(self.handleMBSScriptTexts(true)).substr(0, 700);
        };

        self.shortStoryContent = function(data) {
            var contentToBeSearched = data.substr(0, 700);
            var lastChar = contentToBeSearched.substr(contentToBeSearched.length - 1, 1);
            if (lastChar == '.' || lastChar == '?' || lastChar == '!') {
                return contentToBeSearched;
            } else {
                var breakIndex = self.returnBreakIndex(contentToBeSearched);
                return contentToBeSearched.substr(0, breakIndex + 1);
            }
        };

        self.returnBreakIndex = function(contentToBeSearched) {
            var indexArray = [];

            indexArray[indexArray.length] = contentToBeSearched.lastIndexOf('.');
            indexArray[indexArray.length] = contentToBeSearched.lastIndexOf('?');
            indexArray[indexArray.length] = contentToBeSearched.lastIndexOf('!');

            var index = 0;
            do {
                if (indexArray[index] === -1) {
                    indexArray.splice(index, 1);
                } else {
                    index = index + 1;
                }
            } while (index < indexArray.length);

            return Array.min(indexArray);
        };

        // extending the prototype to add min function in array
        Array.min = function(array) {
            return Math.min(...array);
        };


        self.model.sendMail = function(id) {
            var emailId = 'test@test.com';
            var subject = 'My Script';
            self.createTextArea();
            $window.open('mailto:' + emailId + '?subject=' + subject + '&body=' + message, '_self');
        };

        self.createTextArea = function() {
            var t = document.createElement('textarea');
            t.id = 't';
            t.style.height = 0;
            document.body.appendChild(t);
            t.value = document.getElementById(id).innerText;
            document.body.removeChild(t);
        };

        self.model.printControl = function(id) {
            var printContents = document.getElementById(id).innerHTML;
            var popupWin = $window.open('', '_blank', 'width=800,height=800');
            popupWin.document.open();
            popupWin.document.write('<html><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        };

        self.model.copyClip = function(headingId, subHeadingId, dateTimeId) {
            var heading = angular.element('#' + headingId).html();
            var subHeading = angular.element('#' + subHeadingId).html();
            var formattedDate = moment(self.model.getDatetime, marketDateMaskFormat);
            var dateTime = formattedDate.format(marketDateMaskFormat);
            self.model.isCopyClicked = true;
            var t = document.createElement('textarea');
            t.id = 't';
            t.style.height = 0;
            document.body.appendChild(t);
            t.value = heading.toUpperCase() + '\n\n' + subHeading.toUpperCase() + '\n\n'
                + dateTime + '\n\n' + self.handleMBSScriptTexts(true);
            var selector = document.querySelector('#t');
            selector.select();
            document.execCommand('copy');
            document.body.removeChild(t);
            $timeout(function() {
                self.model.isCopyClicked = false;
            }, 5000);
        };

        self.model.downloadAsPdf = function(headingId, subHeadingId, datetimeId) {
            var formattedDate = moment(self.model.getDatetime, marketDateMaskFormat);
            var datetime = formattedDate.format(marketDateMaskFormat);
            var content = self.handleMBSScriptTexts(true);
            var heading = angular.element('#' + headingId).html();
            var subHeading = angular.element('#' + subHeadingId).html();
            pdfMake.fonts = {
                proximaNova: {
                    normal: 'proximanova-regular.ttf',
                    bold: 'Roboto-Medium.ttf',
                    italics: 'proximanova-light.ttf',
                    bolditalics: 'proximanova-semibold.ttf'
                }
            };
            var docDefinition = {
                content: [{
                    image: imageDocs.primaryDoc,
                    width: 35,
                    height: 35,
                    margin: [240, -30, 275, 12],
                }, {
                    image: imageDocs.secondaryDoc,
                    width: 700,
                    height: 150,
                    margin: [-40, 0, -80, 0]
                }, {
                    text: heading,
                    style: 'header',
                    margin: [0, -100, 0, 0]
                },
                {text: subHeading, style: 'myscript'},
                {text: datetime, style: 'datetime'},
                {text: content, style: 'body'}
                ],
                defaultStyle: {
                    font: 'proximaNova'
                },
                styles: {
                    header: {
                        fontSize: 24,
                        alignment: 'center',
                        color: '#ffffff',
                        margin: [0, 60, 0, 0]
                    },
                    myscript: {
                        fontSize: 18,
                        alignment: 'left',
                        color: '#a7a7a7',
                        margin: [0, 100, 0, 0]
                    },
                    datetime: {
                        fontSize: 11,
                        alignment: 'left',
                        color: '#a7a7a7',
                        margin: [0, 2, 0, 36]
                    },
                    body: {
                        fontSize: 13,
                        alignment: 'left',
                        color: '#727272',
                        lineHeight: 1.5,
                        bolditalics: true
                    }
                }
            };

            pdfMake.createPdf(docDefinition).download('myStory.pdf');
        };

        self.model.getDatetime = new Date();

        self.model.openScript = function(scriptPage) {
            // TODO redirect to Story Script page
            $window.location = $window.location.protocol + '//' + $window.location.host
                + scriptPage + '.html?outsideMBS=yes';
        };

        self.model.openOverview = function(Overviewpath) {
            // TODO redirect to Overview page
            $window.location = $window.location.protocol + '//' + $window.location.host + Overviewpath + '.html';
        };

        self.model.checkCCMonth = function() {
            if (self.model.currentbilling.cardexpiry) {
                // mm/yy format
                var cardExpDate =self.model.currentbilling.cardexpiry.substr(0, 2) + '/'
                    +self.model.currentbilling.cardexpiry.substr(self.model.currentbilling.cardexpiry.length - 2);
                var expdatearr = cardExpDate.split('/');
                if (expdatearr[0] > 12 || expdatearr[0] < 1) {
                    self.model.showCCExpError = true;
                }
            }
        };

        self.model.showLoader = function(showgloballoader, timeoutPeriod) {
            if (showgloballoader == false) {
                $rootScope.showGlobalLoader = false;
                document.getElementById('ns-accounts-global-loader');
                document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
            } else {
                if (showgloballoader == true) {
                    $rootScope.showGlobalLoader = true;
                    $timeout(function() {
                        if ($rootScope.showGlobalLoader) {
                            document.getElementById('ns-accounts-global-loader');
                            document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
                            $rootScope.showGlobalLoader = false;
                        }
                    }, timeoutPeriod);
                    document.getElementById('ns-accounts-global-loader');
                    document.getElementById('ns-accounts-global-loader').setAttribute('opened', '');
                }
            }
        };

        self.model.emailUsernameVerification = function(userName) {
            var emailVerificcationTemplate = 'emailverification.html';
            var data = {};
            data.sendToEmail = self.model.loginPref.username;

            personalService.sendUserNameVerificationEmail(data);

            self.resendemailpopupHeader = strings.get('tdc_resendemailpopupHeader');
            self.resendemailpopupBeforeEmail = strings.get('tdc_resendemailpopupBeforeEmail');
            self.resendemailpopupAfterEmail = strings.get('tdc_resendemailpopupAfterEmail');
            self.resendemailpopupBeforePhone = strings.get('tdc_resendemailpopupBeforePhone');
            self.resendemailpopupPhone = strings.get('resendemailpopupPhone');
            self.resendemailpopupAfterPhone = strings.get('tdc_resendemailpopupAfterPhone');
            self.resendemailpopupResendButton = strings.get('tdc_resendemailpopupResendButton');
            modalPopupInstance(emailVerificcationTemplate, 'emailVerification',
                'app-modal-window email-username-popup', true, self);
        };
        angular.element('#contact,#personaldetails,#loginpref,#billing,#shipping,#communication,#family,' +
            '#privacy,#branded').on('shown.bs.collapse', function(event) {
            event.target.parentElement.scrollIntoView();
        });
    }]);



//////////////////
// WEBPACK FOOTER
// ./views/pages/personal/personal.js
// module id = 370
// module chunks = 0